<template>
  <div class="detail-box">
    <span href class="el-back" @click="back">
      <i class="el-icon-refresh-left" />
    </span>

    <ul class="select-option" style="display: inline-block; height: 40px">
      <el-button
        type="primary"
        @click.stop="historyDialog = true"
      >历史处理记录</el-button>
      <el-button type="primary" @click.stop="fileDialog = true">查看影像</el-button>
      <li v-if="checkPermission('资料:查看材料链接', permList)">
        <el-button type="primary" @click.stop="seeLinks">查看材料链接</el-button>
      </li>
      <li v-if="checkPermission('电子材料:发送邮件通知', permList)">
        <el-button type="primary" @click="sendEmail">发送邮件通知</el-button>
      </li>
      <li v-if="checkPermission('电子材料:生成调查表', permList)">
        <el-button
          type="primary"
          @click.stop="showdrawerbox('questionary01')"
        >生成调查表</el-button>
      </li>
      <li v-if="checkPermission('电子材料:生成调查函', permList)">
        <el-button
          type="primary"
          @click.stop="showdrawerbox('questionary02')"
        >生成调查函</el-button>
      </li>
      <li v-if="checkPermission('补充资料:查看', permList)">
        <el-button type="primary" @click="moreInfo">补充资料</el-button>
      </li>
      <li v-if="checkPermission('变更受助人信息:查看和修改', permList)">
        <el-button type="primary" @click="changeCaseInfo">变更受助人信息</el-button>
      </li>
      <li>
        <el-button
          v-if="checkPermission('设为特殊案件', permList) && cases.isSpecial == false"
          type="primary"
          @click="moveCase('toSpecial', '')"
        >设为特殊案件</el-button>
        <el-button
          v-else-if="checkPermission('设为普通案件', permList) && cases.isSpecial == true"
          type="primary"
          @click="moveCase('removeSpecial', '')"
        >设为普通案件</el-button>
      </li>
      <li
        v-if="
          cases.flowCode != 103001 && cases.flowCode != 103501 && cases.isStation == false
        "
      >
        <el-button
          type="primary"
          @click="moveCase('toStation', '')"
        >移动到中转流程</el-button>
      </li>
    </ul>
    <!--申请信息-->
    <div class="caseInfo">
      <div class="title-line">
        <span class="divider-title">申请资料</span>
      </div>
      <div class="part_line">
        <div class="search-con-item">
          <label class="search-con-item__label">事件ID:</label>
          <span>{{ cases.caseId }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">受助人姓名:</label>
          <span>{{ cases.recRealName }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">受助人身份证号:</label>
          <span>{{ cases.recIdno }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">受助人联系电话:</label>
          <span>{{ cases.recPhoneNumber }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">联系邮箱:</label>
          <span>{{ cases.recMailbox }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">微信号:</label>
          <span>{{ cases.recWxNumber }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">性别:</label>
          <span>{{ cases.sexName }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">职业:</label>
          <span>{{ cases.career }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">联系地址:</label>
          <span>{{ cases.recResidentAddress }}</span>
        </div>
      </div>
      <div class="part_line">
        <div class="search-con-item">
          <label class="search-con-item__label">申请人姓名:</label>
          <span>{{ cases.applicantName }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">申请人身份证号:</label>
          <span>{{ cases.applicantIdno }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">申请人联系电话:</label>
          <span>{{ cases.applicantPhoneNumber }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">与受助人关系:</label>
          <span>{{ cases.relationship }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">联系邮箱:</label>
          <span>{{ cases.applicantMailbox }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">微信号:</label>
          <span>{{ cases.applicantWxNumber }}</span>
          <span v-if="cases.applicantWxNumber">
            <span
              v-if="cases.applicantWxCheck"
              style="color: green; font-weight: bold"
            >&nbsp;&nbsp; 已验证</span>
            <span v-else style="color: red">
              &nbsp;&nbsp;未验证 &nbsp;&nbsp;
              <el-button
                class="ml10"
                type="text"
                size="medium"
                @click="copyCheckUrl"
              >复制验证链接</el-button>
            </span>
          </span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">直接推荐人:</label>
          <span>{{ cases.refRealName }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">推荐人联系电话:</label>
          <span>{{ cases.refMobileNO }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">用户类型:</label>
          <span>{{ cases.positions }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">所属机构:</label>
          <span>{{ cases.comname }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">应缴/实缴调查费:</label>
          <span>{{ cases.surveyFee || 0 }}元/{{ cases.realSurveyFee || 0 }}元</span>
        </div>
      </div>
      <div class="part_line">
        <div class="search-con-item">
          <label class="search-con-item__label">互助计划:</label>
          <span>{{ cases.productName }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">加入时间:</label>
          <span>{{ cases.joinTime }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">生效时间:</label>
          <span>{{ cases.effectiveTime }}</span>
        </div>
        <div v-if="cases.waitingDateFlag != null" class="search-con-item">
          <span style="font-weight: bold">[{{ cases.waitingDateFlag }}]</span>
        </div>
        <div class="search-con-item">
          <label for class="search-con-item__label">立案时间:</label>
          <span>{{ cases.caseFilingTime }}</span>
        </div>
        <div class="search-con-item">
          <label for class="search-con-item__label">总加入时长:</label>
          <span>{{ cases.allJoinTime }}天</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">少儿呼吸道:</label>
          <span
            v-if="
              cases.diseaseIcdInfo != undefined &&
                cases.diseaseIcdInfo != null &&
                cases.diseaseIcdInfo.degreeType == 1
            "
          >是</span>
          <span v-else>否</span>
        </div>
      </div>
      <div class="part_line">
        <div class="search-con-item">
          <label class="search-con-item__label">收款人:</label>
          <span>{{ cases.payee }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">开户银行:</label>
          <span>{{ cases.bankName }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">卡号:</label>
          <span>{{ cases.bankCard }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">支行信息:</label>
          <span>{{ cases.branchInfo }}</span>
        </div>
      </div>

      <template v-if="cases.caseWarnResInfo != null">
        <div v-for="(item, index) in cases.caseWarnResInfo.list" :key="index">
          <div class="search-con-item">
            <label class="search-con-item__label">{{ item.title }}：</label>
            <span>
              <span v-if="item.currentTimes > item.times" style="color: red">{{
                item.currentTimes
              }}</span>
              <span v-else>{{ item.currentTimes }}</span>
              /
              <span>{{ item.times }}</span>
              <span style="margin-left: 5px">
                <span v-if="item.type == 1">工作日</span>
                <span v-else-if="item.type == 2">自然日</span>
              </span>
            </span>
          </div>
        </div>
      </template>
    </div>
    <!--事件信息-->
    <div class="helpInfo">
      <div class="title-line">
        <span class="divider-title">事件信息</span>
      </div>
      <!-- *******************************抗癌不可编辑**************************** -->
      <div v-if="cases.flowCode">
        <!-- 有查看权限  且  （没有可改权限 或 不在指定流程） 且 是抗癌 -->
        <!-- 2020-07-31 新增“复查-已审批”状态下，事件信息显示不可编辑状态内容 -->
        <div
          v-if="
            checkPermission('初审:互助信息:查看', permList) &&
              (!checkPermission('初审:互助信息:可改', permList) ||
              ((cases.flowCode + '').substring(0, 4) != '1000' &&
              (cases.flowCode + '').substring(0, 4) != '1005' &&
              (cases.flowCode + '').substring(0, 4) != '1010' &&
              (cases.flowCode + '').substring(0, 4) != '1015') ||
              cases.flowCode == '101570') &&
              cases.productName.substring(0, 2) == '抗癌'
          "
          class="search-con"
        >
          <div class="part_line">
            <div class="search-con-item">
              <label class="search-con-item__label">诊断名称:</label>
              <span>{{ cases.diseaseIcdInfo.icdName }}</span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">ICD-10:</label>
              <span>{{
                cases.diseaseIcdInfo.icdCode == ""
                  ? "未选择"
                  : cases.diseaseIcdInfo.icdCode
              }}</span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">TNM分期:</label>
              <span>{{ cases.tnmName }}</span>
            </div>
            <div
              v-if="cases.degreeName != undefined && cases.degreeName != ''"
              class="search-con-item"
            >
              <label class="search-con-item__label">疾病名称:</label>
              <span>{{ cases.degreeName }}</span>
            </div>
            <div
              v-if="cases.libraryName != undefined && cases.libraryName != ''"
              class="search-con-item"
            >
              <label class="search-con-item__label">疾病类型:</label>
              <span>{{ cases.libraryName }}</span>
            </div>
            <div v-if="!cases.aidMultiple" class="search-con-item">
              <label class="search-con-item__label">互助标准:</label>
              <span>{{ getKyMutualStandardName }}</span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">首次确诊时间:</label>
              <span>{{ cases.firstDiagnosisTime }}</span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">发病时间:</label>
              <span>{{ cases.symptomAppearanceTime }}</span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">最高互助金:</label>
              <span>{{ cases.mutualMoney / 10000 }}万元</span>
            </div>
            <div v-if="cases.aidMultiple > 0" class="search-con-item red">
              <label class="search-con-item__label">互助倍数:</label>
              <span>{{ cases.aidMultiple }}</span>
            </div>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">生活轨迹:</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.lifeTrack"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in lifeTrack"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in lifeTrack" v-else :key="index">
                <span v-if="cases.lifeTrack == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>

          <div class="search-con-item">
            <label class="search-con-item__label">欺诈风险:</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.hiddenDiseaseHistory"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, hiddenIdx) in hiddenDiseaseHistory"
                  :key="hiddenIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span
                v-for="(item, hiddenIdx) in hiddenDiseaseHistory"
                v-else
                :key="hiddenIdx"
              >
                <span v-if="cases.hiddenDiseaseHistory == item.code">{{
                  item.name
                }}</span>
              </span>
            </span>
          </div>

          <div class="search-con-item">
            <label class="search-con-item__label">第三方保险/互助投保情况：</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.thirdPartyInsurance"
                placeholder="请选择"
                @change="thirdPartyInsuranceChange"
              >
                <el-option
                  v-for="(item, thirdIdx) in thirdPartyInsurance"
                  :key="thirdIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span
                v-for="(item, thirdIdx) in thirdPartyInsurance"
                v-else
                :key="thirdIdx"
              >
                <span v-if="cases.thirdPartyInsurance == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">职业：</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) === '1005'"
                v-model="cases.riskAppend"
                placeholder="请选择"
                @change="riskAppendChange"
              >
                <el-option
                  v-for="(item, riskIdx) in riskAppend"
                  :key="riskIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, riskIdx) in riskAppend" v-else :key="riskIdx">
                <span v-if="cases.riskAppend == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>

          <div class="search-con-item">
            <label class="search-con-item__label">案件风险度:</label>
            <span>{{ cases.caseRisk }}</span>
          </div>

          <div class="search-con-item">
            <label for class="search-con-item__label">是否特殊案件：</label>
            <span v-if="cases.isSpecial" style="color: red">特殊案件</span>
            <span v-else>普通案件</span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">是否需要调查:</label>
            <span>{{ surveyPayResult }}</span>
          </div>

          <div class="search-con-item">
            <label class="search-con-item__label">收费类型:</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.chargeType"
                placeholder="请选择"
                @change="chargeTypeChange"
              >
                <el-option
                  v-for="(item, chareIdx) in chareTypeList"
                  :key="chareIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-else>
                <span
                  v-for="(item, chareIdx) in chareTypeList.filter(
                    (item) => item.code == cases.chargeType
                  )"
                  :key="chareIdx"
                >{{ item.name }}</span>
              </span>
            </span>
          </div>
          <br>
          <el-button
            v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
            type="primary"
            icon="el-icon-edit"
            :loading="applyloading"
            @click.stop="updateRechargeInfo"
          >保存收费类型</el-button>

          <div v-if="cases.flowCode >= 102500">
            <div class="search-con-item">
              <label for class="search-con-item__label">公示期:</label>
              <span>{{ cases.publicityStart }}~{{ cases.publicityEnd }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">公示编号:</label>
              <span>{{ cases.publicityNumber }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">公示内容:</label>
              <span>{{ cases.publicityContent }}</span>
            </div>
          </div>
          <div v-if="cases.flowCode >= 103000">
            <div class="search-con-item">
              <label for class="search-con-item__label">归档编号:</label>
              <span>{{ cases.archiveNumber }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">归档内容:</label>
              <span>{{ cases.archiveContent }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- ******************************抗癌可编辑***************************** -->
      <div v-if="cases.flowCode">
        <div
          v-if="
            checkPermission('初审:互助信息:可改', permList) &&
              cases.productName.substring(0, 2) == '抗癌' &&
              ((cases.flowCode + '').substring(0, 4) == '1000' ||
              (cases.flowCode + '').substring(0, 4) == '1005' ||
              (cases.flowCode + '').substring(0, 4) == '1010' ||
              (cases.flowCode + '').substring(0, 4) == '1015') &&
              cases.flowCode != '101570'
          "
          class="search-con"
        >
          <div class="part_line">
            <div class="search-con-item">
              <label for class="search-con-item__label">诊断名称:</label>
              <span>
                <el-autocomplete
                  v-model="cases.diseaseIcdInfo.icdName"
                  style="width: 250px"
                  class="autocomplete-input"
                  :fetch-suggestions="querySearch_front"
                  placeholder="请输入诊断名称"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                />
              </span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">ICD-10:</label>
              <span>{{
                cases.diseaseIcdInfo.icdCode == ""
                  ? "未选择"
                  : cases.diseaseIcdInfo.icdCode
              }}</span>
            </div>
            <!-- <div class="search-con-item">
							<label for="" class="search-con-item__label">肿瘤形态学编码:</label>
							<span>
								<el-cascader
									ref="disease"
									v-model="cases.diseaseCode"
									:show-all-levels="false"
									:options="diseaseList"
									:props="diseaseProps"
									@change="diseaseChange"
									placeholder="肿瘤形态学编码"
								>
								</el-cascader>
							</span>
						</div>
						<div class="search-con-item">
							<label for="" class="search-con-item__label">疾病类型:</label>
							<span>{{cases.libraryName}}</span>
            </div>-->
            <div class="search-con-item">
              <label for class="search-con-item__label">TNM分期:</label>
              <span>
                <el-cascader
                  ref="tnm"
                  v-model="cases.tnmName"
                  :options="tnmTreeList"
                  :props="tnmProps"
                  :placeholder="cases.tnmName"
                  @change="tnmChange"
                />
              </span>
            </div>
            <div
              v-if="cases.degreeName != undefined && cases.degreeName != ''"
              class="search-con-item"
            >
              <label for class="search-con-item__label">疾病名称:</label>
              <span>{{ cases.degreeName }}</span>
            </div>
            <div
              v-if="cases.libraryName != undefined && cases.libraryName != ''"
              class="search-con-item"
            >
              <label class="search-con-item__label">疾病类型:</label>
              <span>{{ cases.libraryName }}</span>
            </div>
            <div v-if="!cases.aidMultiple" class="search-con-item">
              <label for class="search-con-item__label">互助标准:</label>
              <span>
                <el-input v-model="getKyMutualStandardName" :disabled="true" />
              </span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">首次确诊时间:</label>
              <el-date-picker
                v-model="cases.firstDiagnosisTime"
                type="date"
                style="width: 150px"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="firstDiagnosisTimeChange"
              />
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">发病时间:</label>
              <el-date-picker
                v-model="cases.symptomAppearanceTime"
                type="date"
                style="width: 150px"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="symptomAppearanceTimeChange"
              />
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">最高互助金:</label>
              <span
                v-if="
                  cases.diseaseIcdInfo != undefined &&
                    cases.diseaseIcdInfo != null &&
                    cases.diseaseIcdInfo.degreeType == 1
                "
              >
                {{ cases.mutualMoney }}元
                <el-button
                  v-if="checkPermission('少儿呼吸首:最高互助金费用计算', permList)"
                  type="primary"
                  @click="calcHelpMoneyBtn()"
                >费用计算</el-button>
              </span>
              <span v-else>{{ cases.mutualMoney / 10000 }}万元</span>
            </div>
            <div v-if="cases.aidMultiple > 0" class="search-con-item red">
              <label class="search-con-item__label">互助倍数:</label>
              <span>{{ cases.aidMultiple }}</span>
            </div>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">生活轨迹:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.lifeTrack"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, lifeIdx) in lifeTrack"
                  :key="lifeIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, lifeIdx) in lifeTrack" v-else :key="lifeIdx">
                <span v-if="cases.lifeTrack == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">欺诈风险:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.hiddenDiseaseHistory"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, hiddenIdx) in hiddenDiseaseHistory"
                  :key="hiddenIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span
                v-for="(item, hiddenIdx) in hiddenDiseaseHistory"
                v-else
                :key="hiddenIdx"
              >
                <span v-if="cases.hiddenDiseaseHistory == item.code">{{
                  item.name
                }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">第三方保险/互助投保情况:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.thirdPartyInsurance"
                placeholder="请选择"
                @change="thirdPartyInsuranceChange"
              >
                <el-option
                  v-for="(item, thirdIdx) in thirdPartyInsurance"
                  :key="thirdIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span
                v-for="(item, thirdIdx) in thirdPartyInsurance"
                v-else
                :key="thirdIdx"
              >
                <span v-if="cases.thirdPartyInsurance == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">职业：</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) === '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.riskAppend"
                placeholder="请选择"
                @change="riskAppendChange"
              >
                <el-option
                  v-for="(item, riskIdx) in riskAppend"
                  :key="riskIdx"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, riskIdx) in riskAppend" v-else :key="riskIdx">
                <span v-if="cases.riskAppend == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">案件风险度:</label>
            <span>{{ cases.caseRisk }}</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">是否特殊案件：</label>
            <span v-if="cases.isSpecial" style="color: red">特殊案件</span>
            <span v-else>普通案件</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">是否需要调查:</label>
            <span>{{ surveyPayResult }}</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">收费类型:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.chargeType"
                placeholder="请选择"
                @change="chargeTypeChange"
              >
                <el-option
                  v-for="(item, index) in chareTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-else>
                <span
                  v-for="(item, index) in chareTypeList.filter(
                    (item) => item.code == cases.chargeType
                  )"
                  :key="index"
                >{{ item.name }}</span>
              </span>
            </span>
          </div>
          <br>
          <el-button
            type="primary"
            icon="el-icon-edit"
            :loading="applyloading"
            @click.stop="saveApplyInfo"
          >保存事件信息</el-button>
        </div>
      </div>
      <!-- *******************************意外不可编辑**************************** -->
      <div v-if="cases.flowCode">
        <!-- 2020-07-31 新增“复查-已审批”状态下，事件信息显示不可编辑状态内容 -->
        <div
          v-if="
            checkPermission('初审:意外互助信息:查看', permList) &&
              (!checkPermission('初审:意外互助信息:可改', permList) ||
              ((cases.flowCode + '').substring(0, 4) != '1000' &&
              (cases.flowCode + '').substring(0, 4) != '1005' &&
              (cases.flowCode + '').substring(0, 4) != '1010' &&
              (cases.flowCode + '').substring(0, 4) != '1015') ||
              cases.flowCode == '101570') &&
              cases.productName.substring(0, 2) == '意外'
          "
        >
          <div class="part_line">
            <div class="search-con-item">
              <label class="search-con-item__label">诊断名称:</label>
              <span>{{ cases.diseaseIcdInfo.icdName }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">ICD-10:</label>
              <span>{{
                cases.diseaseIcdInfo.icdCode == ""
                  ? "未选择"
                  : cases.diseaseIcdInfo.icdCode
              }}</span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">事故发生时间:</label>
              <span>{{ cases.accidentTime }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">会员死亡时间:</label>
              <span>{{ cases.memberDeathTime }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">事故类型:</label>
              <span
                v-for="(item, index) in accidentTypeList.filter(
                  (item) => item.code == cases.accidentTypeName
                )"
                :key="index"
              >{{ item.name }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">事故车辆:</label>
              <span>{{ cases.accidentVehicle }}</span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">驾驶证有效期:</label>
              <span>{{ cases.driverLicenseValid }}</span>
            </div>

            <div style="width: 100%">
              <div class="search-con-item">
                <label for class="search-con-item__label">是否高风险运动:</label>
                <span
                  v-for="(item, index) in isType.filter(
                    (item) => item.code == cases.isRiskMovement
                  )"
                  :key="index"
                  class="mr10"
                >{{ item.name }}</span>
                <span
                  v-for="(item, index) in riskMovementType.filter(
                    (item) => item.code == cases.riskMovement && cases.isRiskMovement == 1
                  )"
                  :key="index"
                >{{ item.name }}</span>
              </div>
              <div v-if="cases.riskMovement == 22" class="search-con-item">
                <label class="search-con-item__label">具体描述:</label>
                <span>{{ cases.riskTaskRemark }}</span>
              </div>
            </div>
            <div style="width: 100%">
              <div class="search-con-item">
                <label class="search-con-item__label">是否高风险职业:</label>
                <span
                  v-for="(item, index) in isType.filter(
                    (item) => item.code == cases.isRiskJob
                  )"
                  :key="index"
                  class="mr10"
                >{{ item.name }}</span>
                <span
                  v-for="(item, index) in riskJobType.filter(
                    (item) => item.code == cases.riskJob && cases.isRiskJob == 1
                  )"
                  :key="index"
                >{{ item.name }}</span>
              </div>
            </div>
            <div style="width: 100%">
              <div class="search-con-item">
                <label class="search-con-item__label">是否高风险作业:</label>
                <span
                  v-for="(item, index) in isType.filter(
                    (item) => item.code == cases.isRiskTask
                  )"
                  :key="index"
                  class="mr10"
                >{{ item.name }}</span>
                <span
                  v-for="(item, index) in riskTaskType.filter(
                    (item) => item.code == cases.riskTask && cases.isRiskTask == 1
                  )"
                  :key="index"
                >{{ item.name }}</span>
              </div>
              <div v-if="cases.isRiskTask == 1" class="search-con-item">
                <label class="search-con-item__label">具体描述:</label>
                <span>{{ cases.riskTaskRemark }}</span>
              </div>
            </div>

            <div style="width: 100%">
              <div v-if="!cases.aidMultiple" class="search-con-item">
                <label class="search-con-item__label">互助标准:</label>
                <span>{{ getYwMutualStandardName }}</span>
              </div>
              <div class="search-con-item">
                <label class="search-con-item__label">最高互助金:</label>
                <span>{{ cases.mutualMoney / 10000 }}万元</span>
              </div>
              <div v-if="cases.aidMultiple > 0" class="search-con-item red">
                <label class="search-con-item__label">互助倍数:</label>
                <span>{{ cases.aidMultiple }}</span>
              </div>
            </div>
          </div>

          <div class="search-con-item">
            <label class="search-con-item__label">生活轨迹:</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.lifeTrack"
                placeholder="请选择"
                @change="lifeTrackChange"
              >
                <el-option
                  v-for="(item, index) in lifeTrack"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in lifeTrack" v-else :key="index">
                <span v-if="cases.lifeTrack == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">欺诈风险:</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.hiddenDiseaseHistory"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in hiddenDiseaseHistory"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in hiddenDiseaseHistory" v-else :key="index">
                <span v-if="cases.hiddenDiseaseHistory == item.code">{{
                  item.name
                }}</span>
              </span>
            </span>
          </div>

          <div class="search-con-item">
            <label for class="search-con-item__label">第三方保险/互助投保情况：</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.thirdPartyInsurance"
                placeholder="请选择"
                @change="thirdPartyInsuranceChange"
              >
                <el-option
                  v-for="(item, index) in thirdPartyInsurance"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in thirdPartyInsurance" v-else :key="index">
                <span v-if="cases.thirdPartyInsurance == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>

          <div class="search-con-item">
            <label for class="search-con-item__label">职业：</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) === '1005'"
                v-model="cases.riskAppend"
                placeholder="请选择"
                @change="riskAppendChange"
              >
                <el-option
                  v-for="(item, index) in riskAppend"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in riskAppend" v-else :key="index">
                <span v-if="cases.riskAppend == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">案件风险度:</label>
            <span>{{ cases.caseRisk }}</span>
          </div>

          <div class="search-con-item">
            <label for class="search-con-item__label">是否特殊案件：</label>
            <span v-if="cases.isSpecial" style="color: red">特殊案件</span>
            <span v-else>普通案件</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">是否需要调查:</label>
            <span>{{ surveyPayResult }}</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">收费类型:</label>
            <span>
              <el-select
                v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
                v-model="cases.chargeType"
                placeholder="请选择"
                @change="chargeTypeChange"
              >
                <el-option
                  v-for="(item, index) in chareTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-else>
                <span
                  v-for="(item, index) in chareTypeList.filter(
                    (item) => item.code == cases.chargeType
                  )"
                  :key="index"
                >{{ item.name }}</span>
              </span>
            </span>
          </div>
          <el-button
            v-if="(cases.flowCode + '').substring(0, 4) == '1005'"
            type="primary"
            icon="el-icon-edit"
            :loading="applyloading"
            @click.stop="updateRechargeInfo"
          >保存收费类型</el-button>
        </div>
        <div v-if="cases.flowCode >= 102500">
          <div class="search-con-item">
            <label for class="search-con-item__label">公示期:</label>
            <span>{{ cases.publicityStart }}~{{ cases.publicityEnd }}</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">公示编号:</label>
            <span>{{ cases.publicityNumber }}</span>
          </div>
          <div class="search-con-item" style="display: block">
            <label for class="search-con-item__label">公示内容:</label>
            <span>{{ cases.publicityContent }}</span>
          </div>
        </div>
        <div v-if="cases.flowCode >= 103000">
          <div class="search-con-item">
            <label for class="search-con-item__label">归档编号:</label>
            <span>{{ cases.archiveNumber }}</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">归档内容:</label>
            <span>{{ cases.archiveContent }}</span>
          </div>
        </div>
      </div>

      <!-- *******************************意外可编辑**************************** -->
      <div v-if="cases.flowCode">
        <div
          v-if="
            checkPermission('初审:意外互助信息:可改', permList) &&
              cases.productName.substring(0, 2) == '意外' &&
              ((cases.flowCode + '').substring(0, 4) == '1000' ||
              (cases.flowCode + '').substring(0, 4) == '1005' ||
              (cases.flowCode + '').substring(0, 4) == '1010' ||
              (cases.flowCode + '').substring(0, 4) == '1015') &&
              cases.flowCode != '101570'
          "
        >
          <div class="part_line">
            <div class="search-con-item">
              <label for class="search-con-item__label">诊断名称:</label>
              <span>
                <el-autocomplete
                  v-model="cases.diseaseIcdInfo.icdName"
                  style="width: 250px"
                  class="inline-input"
                  :fetch-suggestions="querySearch_front"
                  placeholder="请输入诊断名称"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                />
              </span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">ICD-10:</label>
              <span>{{
                cases.diseaseIcdInfo.icdCode == ""
                  ? "未选择"
                  : cases.diseaseIcdInfo.icdCode
              }}</span>
            </div>

            <div class="search-con-item">
              <label for class="search-con-item__label">事故发生时间:</label>
              <el-date-picker
                v-model="cases.accidentTime"
                type="date"
                style="width: 150px"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">会员死亡时间：</label>
              <el-date-picker
                v-model="cases.memberDeathTime"
                type="date"
                style="width: 150px"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">事故类型:</label>
              <span>
                <el-select
                  v-model="cases.accidentTypeName"
                  placeholder="请选择"
                  @change="accidentTypeChange"
                >
                  <el-option
                    v-for="(item, index) in accidentTypeList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  />
                </el-select>
              </span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">事故车辆:</label>
              <span>
                <el-input
                  v-model="cases.accidentVehicle"
                  placeholder="事故车辆"
                />
              </span>
            </div>
            <div class="search-con-item">
              <label for class="search-con-item__label">驾驶证有效期:</label>
              <el-date-picker
                v-model="cases.driverLicenseValid"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </div>
            <div style="width: 100%">
              <div class="search-con-item">
                <label for class="search-con-item__label">是否高风险运动:</label>
                <span class="mr10">
                  <el-select
                    v-model="cases.isRiskMovement"
                    placeholder="请选择"
                    @change="(val) => riskChange(val, true)"
                  >
                    <el-option
                      v-for="(item, index) in isType"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </span>
                <span v-if="cases.isRiskMovement == 1">
                  <el-select v-model="cases.riskMovement" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in riskMovementType"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </span>
              </div>
              <div v-if="cases.riskMovement == 22" class="search-con-item">
                <label for class="search-con-item__label">具体描述:</label>
                <span>
                  <el-input
                    v-model="cases.riskMovementRemark"
                    placeholder="具体描述"
                  />
                </span>
              </div>
            </div>
            <div style="width: 100%">
              <div class="search-con-item">
                <label for class="search-con-item__label">是否高风险职业:</label>
                <span class="mr10">
                  <el-select
                    v-model="cases.isRiskJob"
                    placeholder="请选择"
                    @change="(val) => riskChange(val, true)"
                  >
                    <el-option
                      v-for="(item, index) in isType"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </span>
                <span v-if="cases.isRiskJob == 1">
                  <el-select
                    v-model="cases.riskJob"
                    style="width: 500px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in riskJobType"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </span>
              </div>
            </div>
            <div style="width: 100%">
              <div class="search-con-item">
                <label for class="search-con-item__label">是否高风险作业:</label>
                <span class="mr10">
                  <el-select
                    v-model="cases.isRiskTask"
                    placeholder="请选择"
                    @change="(val) => riskChange(val, true)"
                  >
                    <el-option
                      v-for="(item, index) in isType"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </span>
                <span v-if="cases.isRiskTask == 1">
                  <el-select v-model="cases.riskTask" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in riskTaskType"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </span>
              </div>
              <div v-if="cases.isRiskTask == 1" class="search-con-item">
                <label for class="search-con-item__label">具体描述:</label>
                <span>
                  <el-input
                    v-model="cases.riskTaskRemark"
                    placeholder="具体描述"
                  />
                </span>
              </div>
            </div>

            <div style="width: 100%">
              <div v-if="!cases.aidMultiple" class="search-con-item">
                <label for class="search-con-item__label">互助标准:</label>
                <!-- <span>
                  <el-input v-model="getYwMutualStandardName" :disabled="true"></el-input>
                </span> -->
                <span>
                  <el-select
                    v-model="cases.ywMutualStandard"
                    placeholder="请选择"
                    @change="hzTypeChange"
                  >
                    <el-option
                      v-for="(item, index) in ywhzType"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </span>
              </div>
              <div class="search-con-item">
                <label class="search-con-item__label">最高互助金:</label>
                <span>{{ cases.mutualMoney / 10000 }}万元</span>
              </div>
              <div v-if="cases.aidMultiple > 0" class="search-con-item red">
                <label class="search-con-item__label">互助倍数:</label>
                <span>{{ cases.aidMultiple }}</span>
              </div>
            </div>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">生活轨迹:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.lifeTrack"
                placeholder="请选择"
                @change="lifeTrackChange"
              >
                <el-option
                  v-for="(item, index) in lifeTrack"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in lifeTrack" v-else :key="index">
                <span v-if="cases.lifeTrack == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">欺诈风险:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.hiddenDiseaseHistory"
                placeholder="请选择"
                @change="hiddenDiseaseHistoryChange"
              >
                <el-option
                  v-for="(item, index) in hiddenDiseaseHistory"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in hiddenDiseaseHistory" v-else :key="index">
                <span v-if="cases.hiddenDiseaseHistory == item.code">{{
                  item.name
                }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">第三方保险/互助投保情况:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.thirdPartyInsurance"
                placeholder="请选择"
                @change="thirdPartyInsuranceChange"
              >
                <el-option
                  v-for="(item, index) in thirdPartyInsurance"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in thirdPartyInsurance" v-else :key="index">
                <span v-if="cases.thirdPartyInsurance == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">职业：</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) === '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.riskAppend"
                placeholder="请选择"
                @change="riskAppendChange"
              >
                <el-option
                  v-for="(item, index) in riskAppend"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-for="(item, index) in riskAppend" v-else :key="index">
                <span v-if="cases.riskAppend == item.code">{{ item.name }}</span>
              </span>
            </span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">案件风险度:</label>
            <span>{{ cases.caseRisk }}</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">是否特殊案件：</label>
            <span v-if="cases.isSpecial" style="color: red">特殊案件</span>
            <span v-else>普通案件</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">是否需要调查:</label>
            <span>{{ surveyPayResult }}</span>
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">收费类型:</label>
            <span>
              <el-select
                v-if="
                  (cases.flowCode + '').substring(0, 4) == '1005' ||
                    (cases.flowCode + '').substring(0, 4) == '1000'
                "
                v-model="cases.chargeType"
                placeholder="请选择"
                @change="chargeTypeChange"
              >
                <el-option
                  v-for="(item, index) in chareTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <span v-else>
                <span
                  v-for="(item, index) in chareTypeList.filter(
                    (item) => item.code == cases.chargeType
                  )"
                  :key="index"
                >{{ item.name }}</span>
              </span>
            </span>
          </div>
          <br>
          <el-button
            type="primary"
            icon="el-icon-edit"
            :loading="applyloading"
            @click.stop="saveApplyInfo"
          >保存事件信息</el-button>
        </div>
      </div>
    </div>

    <!--案件信息-->
    <!-- <div class="casemoreInfo" v-if="cases.caseWarnResInfo">
			<div class="title-line">
				<span class="divider-title">案件信息</span>
			</div>
			<div class="search-con">
				<div class="search-con-item">
					<label class="search-con-item__label">是否特殊案件：</label>
					<span style="color: red;" v-if="cases.isSpecial == true">是</span>
					<span v-else>否</span>
				</div>
				<br>
				<div class="search-con-item">
					<label class="search-con-item__label">是否中转案件：</label>
					<span style="color: red;" v-if="cases.isStation == true">是</span>
					<span v-else>否</span>
				</div>
				<div v-for="item in cases.caseWarnResInfo.list">
					<div class="search-con-item">
						<label class="search-con-item__label">{{item.title}}：</label>
						<span>
							<span v-if="item.currentTimes > item.times" style="color: red;" >{{item.currentTimes}}</span>
							<span v-else>{{item.currentTimes}}</span>
							/<span>{{item.times}}</span>
							<span style="margin-left: 5px;">
								<span v-if="item.type==1">工作日</span>
								<span v-else-if="item.type==2">自然日</span>
							</span>

						</span>
					</div>
					<br>
				</div>

				<div class="search-con-item">
					<label class="search-con-item__label">进行中的任务：</label>
					<span><span>{{cases.caseWarnResInfo.goonTaskNum}}</span>个</span>
				</div>
				<br>
				<div class="search-con-item">
					<label class="search-con-item__label">已超时的任务：</label>
					<span><span>{{cases.caseWarnResInfo.timeoutTaskNum}}</span>个</span>
				</div>

				<br>
				<div class="search-con-item" v-if="cases.historyCaseInfo.length > 0">
					<label class="search-con-item__label">关联案件：</label><br>
				</div>
				<div v-if="cases.historyCaseInfo.length > 0" >
					<p style="width: 100%; line-height: 18px; text-indent: 12px; font-size: 12px;" v-for="item in cases.historyCaseInfo">{{item.caseCode}}&nbsp;&nbsp;&nbsp;{{item.createTime}}&nbsp;&nbsp;&nbsp;{{item.caseStatus}}</p>
				</div>
			</div>
    </div>-->

    <!--公示信息-->
    <div v-if="cases.flowCode">
      <div
        v-if="
          checkPermission('公示中:公示信息', permList) &&
            (cases.flowCode + '').substring(0, 4) == '1025'
        "
      >
        <div class="title-line">
          <span class="divider-title">公示信息</span>
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label for class="search-con-item__label">公示期:</label>
            <el-date-picker
              v-model="cases.publicityStart"
              type="date"
              placeholder="公示开始时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
            <span style="margin: 0px 8px">-</span>
            <el-date-picker
              v-model="cases.publicityEnd"
              type="date"
              placeholder="公示结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
          </div>
          <div class="search-con-item">
            <label for class="search-con-item__label">公示编号:</label>
            <span>
              <el-input v-model="cases.publicityNumber" placeholder="公示编号" />
            </span>
          </div>
          <div class="search-con-item" style="display: block">
            <label for style="vertical-align: top">公示内容:</label>
            <span style="width: 600px; display: inline-block">
              <el-input
                v-model="cases.publicityContent"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10 }"
                placeholder="公示内容"
              />
            </span>
          </div>
          <br>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="updatePublicityInfo"
          >保存</el-button>
        </div>
      </div>
    </div>
    <!--归档信息-->
    <div v-if="cases.flowCode">
      <div
        v-if="
          checkPermission('归档:归档信息', permList) &&
            (cases.flowCode + '').substring(0, 4) == '1035'
        "
      >
        <div class="title-line">
          <span class="divider-title">归档信息</span>
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label for class="search-con-item__label">归档编号:</label>
            <span>
              <el-input v-model="cases.archiveNumber" placeholder="归档编号" />
            </span>
          </div>
          <br>
          <div class="search-con-item">
            <label for style="vertical-align: top">归档内容:</label>
            <span style="width: 600px; display: inline-block">
              <el-input
                v-model="cases.archiveContent"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10 }"
                placeholder="归档内容"
              />
            </span>
          </div>
          <br>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="updateArchiveInfo"
          >保存</el-button>
        </div>
      </div>
    </div>
    <div v-if="checkPermission('资料确认信息:查看', permList)" class="title-line">
      <span class="divider-title">资料确认信息</span>
    </div>
    <div
      v-if="checkPermission('资料确认信息:查看', permList)"
      style="overflow-y: auto; height: 400px; padding-right: 20px"
    >
      <div class="search-con">
        <div v-for="(item, index) in testItem" :key="index">
          <rule-item
            :item="item"
            :index="index + 1"
            :perm-list="permList"
            @updateRuleResult="updateRuleResult"
          />
        </div>
      </div>

      <el-button
        v-if="
          checkPermission('资料确认信息:可删', permList) ||
            checkPermission('资料确认信息:可加', permList)
        "
        type="primary"
        icon="el-icon-back"
        @click="saveRule()"
      >保存
      </el-button>
    </div>
    <communicationMoreInfo
      v-if="checkPermission('沟通补充信息:查看', permList)"
      :case-code="cases.caseCode"
      :perm-list="permList"
    />
    <div style="padding: 10px; margin: 10px 0px; background: rgb(234, 241, 255)">
      <!--审核摘要信息-->
      <div class="summary-info">
        <div class="title-line">
          <span class="divider-title">审核摘要</span>
        </div>
        <el-timeline style="margin-top: 25px">
          <el-timeline-item
            v-for="(abstractItem, index) in abstractList"
            :key="index"
          >
            <h6>{{ abstractItem.content }}</h6>
            <p>{{ abstractItem.creator }} 提交于 {{ abstractItem.createTime }}</p>
          </el-timeline-item>
        </el-timeline>
        <div v-if="cases.flowCode">
          <div
            v-if="
              checkPermission('审核:提交审核', permList)
            "
          >
            <el-input
              v-model="abstract.content"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="请输入摘要内容"
            />
            <br>
            <br>
            <el-button
              type="primary"
              icon="el-icon-edit"
              :loading="abstractloading"
              @click.stop="addAbstract(1001)"
            >提交摘要</el-button>
          </div>
        </div>
      </div>
      <!--复审摘要信息-->
      <!-- <div class="summary-info" v-if="cases.flowCode >= 100500">
        <div class="title-line">
          <span class="divider-title">复审摘要</span>
        </div>
        <el-timeline style="margin-top: 25px">
          <el-timeline-item
            v-for="(abstractItem, index) in abstractList.cross"
            :key="index"
          >
            <h6>{{ abstractItem.content }}</h6>
            <p>{{ abstractItem.creator }} 提交于 {{ abstractItem.createTime }}</p>
          </el-timeline-item>
        </el-timeline>
        <div v-if="cases.flowCode">
          <div
            v-if="
              checkPermission('复审:提交摘要', permList) &&
              ((cases.flowCode + '').substring(0, 4) == '1015' ||
                (cases.flowCode + '').substring(0, 4) == '1017' ||
                (cases.flowCode + '').substring(0, 4) == '1005' ||
                (cases.flowCode + '').substring(0, 4) == '1010')
            "
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="请输入摘要内容"
              v-model="abstract.content"
            ></el-input>
            <br />
            <br />
            <el-button
              type="primary"
              icon="el-icon-edit"
              :loading="abstractloading"
              @click.stop="addAbstract"
              >提交摘要</el-button
            >
          </div>
        </div>
      </div> -->
    </div>
    <div
      v-if="answerRuleResult.code == 1 || answerRuleResult.code == 2"
      style="background: #fff3ff; margin: 10px; padding: 10px"
    >
      审核结果：{{ answerRuleResult.name }}
      <br>
      <p v-for="(item, index) in answerRuleResult.reasons" :key="index">
        原因{{ index + 1 }}、{{ item }}
      </p>
    </div>
    <div
      v-if="answerList.length > 0"
      style="margin-top: 10px; border-top: 3px solid #a1a1a1"
    >
      <div class="title-line">
        <span class="divider-title">疑点记录</span>
      </div>
      <div class="search-con">
        <div v-for="(item, index) in answerList" :key="index">
          <answer-item
            :item="item"
            :index="index + 1"
            :perm-list="permList"
            :case-code="cases.caseCode"
            @updateCommunicates="updateCommunicates"
            @updateRuleSuspectData="getCaseRuleSuspectList"
            @updateCaseOperationList="getCaseOperationList"
          />
        </div>
        <div v-if="checkPermission('沟通备注:添加', permList)">
          <el-button
            type="primary"
            icon="el-icon-back"
            @click="saveCommunicates()"
          >保存</el-button>
        </div>
      </div>
    </div>
    <!-- ============================================进度显示=============================================== -->
    <div style="margin-top: 35px">
      <!-- 初审 -->
      <el-steps
        v-if="(cases.flowCode + '').substring(0, 4) == '1000'"
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode >= 100001"
          title="核查报案信息"
          status="success"
        />
        <el-step v-else title="核查报案信息" />
        <el-step
          v-if="cases.flowCode >= 100005"
          title="事件内容评估"
          status="success"
        />
        <el-step v-else title="事件内容评估" />
        <el-step
          v-if="cases.flowCode >= 100010"
          title="回访并通知邮寄材料"
          status="success"
        />
        <el-step v-else title="回访并通知邮寄材料" />
        <el-step
          v-if="cases.flowCode >= 100030"
          title="纸质材料处理"
          status="success"
        />
        <el-step v-else title="纸质材料处理" />
        <el-step
          v-if="cases.flowCode >= 100035"
          title="核对材料"
          status="success"
        />
        <el-step v-else title="核对材料" />
        <el-step
          v-if="cases.flowCode >= 100055"
          title="审核补充资料"
          status="success"
        />
        <el-step v-else title="审核补充资料" />
        <el-step
          v-if="cases.flowCode >= 100060"
          title="输出初审结果"
          status="success"
        />
        <el-step v-else title="输出初审结果" />
      </el-steps>
      <!-- 缴费 -->
      <el-steps
        v-else-if="(cases.flowCode + '').substring(0, 4) == '1005'"
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode <= 100599"
          title="确定去调查"
          status="success"
        />
        <el-step v-else title="确定去调查" />
        <el-step
          v-if="cases.flowCode < 100599 && cases.flowCode >= 100501"
          title="邮件通知立案"
          status="success"
        />
        <el-step v-else title="邮件通知立案" />
        <el-step
          v-if="cases.flowCode < 100599 && cases.flowCode >= 100505"
          title="通知及确认缴费"
          status="success"
        />
        <el-step v-else title="通知及确认缴费" />
      </el-steps>
      <!-- 公估 -->
      <el-steps
        v-else-if="(cases.flowCode + '').substring(0, 4) == '1010'"
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode >= 101005"
          title="委派公估"
          status="success"
        />
        <el-step v-else title="委派公估" />
        <el-step
          v-if="cases.flowCode >= 101010"
          title="接单确认"
          status="success"
        />
        <el-step v-else title="接单确认" />
        <el-step v-if="cases.flowCode >= 101015" title="回访" status="success" />
        <el-step v-else title="回访" />
        <el-step
          v-if="cases.flowCode >= 101020"
          title="上传公估结果"
          status="success"
        />
        <el-step v-else title="上传公估结果" />
      </el-steps>
      <!-- 复审 -->
      <el-steps
        v-else-if="(cases.flowCode + '').substring(0, 4) == '1015'"
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode >= 101501"
          title="事件内容评估"
          status="success"
        />
        <el-step v-else title="事件内容评估" />
        <el-step
          v-if="cases.flowCode >= 101505"
          title="审核公估调查内容"
          status="success"
        />
        <el-step v-else title="审核公估调查内容" />
        <el-step
          v-if="cases.flowCode >= 101510"
          title="通知并查收补充资料"
          status="success"
        />
        <el-step v-else title="通知并查收补充资料" />
        <el-step
          v-if="cases.flowCode >= 101535"
          title="输出复审结果"
          status="success"
        />
        <el-step v-else title="输出复审结果" />
        <el-step
          v-if="cases.flowCode >= 101550"
          title="输出审批结果"
          status="success"
        />
        <el-step v-else title="输出审批结果" />
        <el-step
          v-if="cases.flowCode >= 101560"
          title="输出三审结果"
          status="success"
        />
        <el-step v-else title="输出三审结果" />
        <el-step
          v-if="cases.flowCode >= 101570"
          title="已审批"
          status="success"
        />
        <el-step v-else title="已审批" />
      </el-steps>
      <!-- 交叉审 -->
      <el-steps
        v-else-if="(cases.flowCode + '').substring(0, 4) == '1017'"
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode >= 101701"
          title="事件内容评估"
          status="success"
        />
        <el-step v-else title="事件内容评估" />
        <el-step
          v-if="cases.flowCode >= 101705"
          title="审核公估调查内容"
          status="success"
        />
        <el-step v-else title="审核公估调查内容" />
        <el-step
          v-if="cases.flowCode >= 101710"
          title="通知并查收补充资料"
          status="success"
        />
        <el-step v-else title="通知并查收补充资料" />
        <el-step
          v-if="cases.flowCode >= 101735"
          title="输出复审结果"
          status="success"
        />
        <el-step v-else title="输出复审结果" />
      </el-steps>
      <!-- 待公示 -->
      <el-steps
        v-else-if="(cases.flowCode + '').substring(0, 4) == '1020'"
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode >= 102001"
          title="邮件告知用户"
          status="success"
        />
        <el-step v-else title="邮件告知用户" />
        <el-step
          v-if="cases.flowCode >= 102005"
          title="确认已缴费"
          status="success"
        />
        <el-step v-else title="确认已缴费" />
        <el-step
          v-if="cases.flowCode >= 102010"
          title="查收公证材料"
          status="success"
        />
        <el-step v-else title="查收公证材料" />
        <el-step
          v-if="cases.flowCode >= 102015"
          title="核对银行账号"
          status="success"
        />
        <el-step v-else title="核对银行账号" />
        <el-step
          v-if="cases.flowCode >= 102030"
          title="回收调查意见表"
          status="success"
        />
        <el-step v-else title="回收调查意见表" />
        <el-step
          v-if="cases.flowCode >= 102035"
          title="确认已完成助力"
          status="success"
        />
        <el-step v-else title="确认已完成助力" />
        <el-step
          v-if="cases.flowCode >= 102070"
          title="进入业管端"
          status="success"
        />
        <el-step v-else title="进入业管端" />
      </el-steps>
      <!-- 可公示 -->
      <el-steps
        v-else-if="(cases.flowCode + '').substring(0, 4) == '1025'"
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode >= 102501"
          title="邮件通知用户进入公示期"
          status="success"
        />
        <el-step v-else title="邮件通知用户进入公示期" />
        <el-step v-if="cases.flowCode >= 102505" title="扣款" status="success" />
        <el-step v-else title="扣款" />
        <el-step
          v-if="cases.flowCode >= 102510"
          title="收取收据"
          status="success"
        />
        <el-step v-else title="收取收据" />
      </el-steps>
      <!-- 待归档 -->
      <el-steps
        v-else-if="(cases.flowCode + '').substring(0, 4) == '1030'"
        :space="160"
        :align-center="true"
      >
        <!-- 待归档：确认结果（待归档） -->
        <template v-if="cases.flowCode == 103001">
          <el-step
            v-if="cases.processResultEnum != 'PROCESS'"
            title="邮件告知用户结果"
            status="success"
          />
          <el-step
            v-if="cases.processResultEnum == 'PROCESS'"
            title="确认归档"
            status="success"
          />
        </template>
        <!-- 待归档：合议 -->
        <el-step
          v-else-if="cases.flowCode == 103050"
          title="去法务"
          status="success"
        />
        <!-- 待归档：法务 -->
        <el-step
          v-else-if="cases.flowCode == 103075"
          title="去归档"
          status="success"
        />
      </el-steps>
      <!-- 归档(只有不予互助的才能重新发起) -->
      <el-steps
        v-else-if="
          (cases.flowCode + '').substring(0, 4) == '1035' &&
            cases.processResultEnum != 'PROCESS'
        "
        :space="160"
        :align-center="true"
      >
        <el-step
          v-if="cases.flowCode >= 103501"
          title="退回到合议"
          status="success"
        />
        <el-step v-else title="退回到合议" />
      </el-steps>
    </div>

    <!-- =================================按钮================================================= -->
    <div style="margin-top: 35px">
      <!-- ******初审*******-->
      <p
        v-if="checkPermission('初审:核查报案信息', permList) && cases.flowCode == 100001"
      >
        <!-- <el-button v-if="cases.hadPrevButton==true" type="primary" icon="el-icon-back" @click.stop="updateFlow(operateEnums.PREVIOUSFLOW,'上一步')">上一步</el-button>
					<el-button type="primary" icon="iconfont icon-xiugai" @click.prevent="updateFlow(operateEnums.NEXTSTEP,'报案信息已核')" >报案信息已核</el-button>
        <el-button type="primary" icon="iconfont icon-xiugai" @click.prevent="updateFlow(operateEnums.WITHDRAWAL,'报案信息不合格，撤案')">报案信息不合格，撤案</el-button>-->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '报案信息已核')"
        >下一步</el-button>
      </p>
      <p
        v-if="checkPermission('初审:事件内容评估', permList) && cases.flowCode == 100005"
      >
        <!--抗癌-->
        <!-- <el-button v-if="cases.productId != '000000000101002'" type="primary" icon="iconfont icon-xiugai" @click="showdrawerbox('reportAssess')">事件内容评估</el-button> -->
        <!--意外-->
        <!-- <el-button v-if="cases.productId == '000000000101002'" type="primary" icon="iconfont icon-xiugai" @click="showdrawerbox('reportAssess_Accident')" >事件内容评估</el-button> -->

        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '事件内容评估')"
        >下一步</el-button>
      </p>
      <p
        v-if="checkPermission('初审:事件内容评估', permList) && cases.flowCode == 100007"
      />
      <p
        v-if="
          checkPermission('初审:回访并通知邮寄材料:发邮件', permList) &&
            cases.flowCode == 100015
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.NEXTSTEP, '发提交材料邮件')"
        >发提交材料邮件</el-button>
      </p>
      <p
        v-if="
          checkPermission('初审:回访并通知邮寄材料:回访', permList) &&
            cases.flowCode == 100020
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.UNOPERATING, '回访电话未接通')"
        >回访电话未接通</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.UNOPERATING, '回访电话未完成')"
        >未完成</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.NEXTSTEP, '已回访')"
        >已回访</el-button>
        <!-- <el-button type="primary" @click.stop="updateFlow(operateEnums.REFUSAL,'失联不予互助')" icon="iconfont icon-xiugai">失联不予互助</el-button> -->
      </p>
      <p
        v-if="
          checkPermission('初审:回访并通知邮寄材料:邮件结果', permList) &&
            cases.flowCode == 100025
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.NEXTSTEP, '收到材料')"
        >收到材料</el-button>
      </p>
      <p
        v-if="checkPermission('初审:纸质材料处理', permList) && cases.flowCode == 100030"
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.NEXTSTEP, '已扫描上传存档')"
        >已扫描上传存档</el-button>
      </p>
      <p
        v-if="
          checkPermission('初审:核对材料:资料是否完整', permList) &&
            cases.flowCode == 100040
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.CYCLE, '资料未完整，邮件通知补交', '', true)"
        >资料未完整，邮件通知补交</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '资料合格完整', '', false)"
        >资料合格完整</el-button>
      </p>
      <p
        v-if="
          checkPermission('初审:核对材料:已收到资料', permList) &&
            cases.flowCode == 100045
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已收到材料')"
        >已收到材料</el-button>
      </p>
      <p
        v-if="checkPermission('初审:审核补充资料', permList) && cases.flowCode == 100055"
      >
        <!--抗癌-->
        <!-- <el-button type="primary" v-if="cases.productId != '000000000101002'" icon="iconfont icon-xiugai" @click="showdrawerbox('reportSupplementAssess')">审核补充资料</el-button> -->
        <!--意外-->
        <!-- <el-button type="primary" v-if="cases.productId == '000000000101002'" icon="iconfont icon-xiugai" @click="showdrawerbox('reportSupplementAssess_Accident')">审核补充资料</el-button> -->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '审核补充资料')"
        >下一步</el-button>
      </p>
      <p
        v-if="checkPermission('初审:审核补充资料', permList) && cases.flowCode == 100057"
      >
        <!-- <el-button v-if="cases.hadPrevButton==true" type="primary" icon="el-icon-back" @click.stop="updateFlow(operateEnums.PREVIOUSFLOW,'上一步')">上一步</el-button> -->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="
            updateFlow(
              operateEnums.NEXTSTEP,
              '审核补充资料',
              'reportSupplementAssessNext'
            )
          "
        >审核补充资料</el-button>
        <!-- <el-button type="primary" icon="iconfont icon-xiugai" @click.prevent="updateFlow(operateEnums.NEXTSTEP,'审核补充资料')" >下一步</el-button> -->
      </p>
      <p
        v-if="checkPermission('初审:输出初审结果', permList) && cases.flowCode == 100060"
      >
        <!-- <el-tag type="info" style="margin: 0px 8px; line-height: 40px; height:40px;">本次处理：{{ trailResult }} </el-tag><br><br>
					<el-button v-if="cases.hadPrevButton==true" type="primary" icon="el-icon-back" @click.stop="updateFlow(operateEnums.PREVIOUSFLOW,'上一步')">上一步</el-button>
					<el-button type="primary" icon="iconfont icon-xiugai" @click="saveFirstTrailResult">输出初审结果</el-button>
        <el-button v-if="cases.isPayRefusal==true" type="primary" icon="iconfont icon-xiugai" @click="showdrawerbox('toFile','审批不予互助')">不予互助</el-button>-->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '输出初审结果')"
        >下一步</el-button>
      </p>

      <!-- *******缴费******-->

      <p v-if="checkPermission('缴费:是否去调查', permList) && cases.flowCode == 100599">
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '去调查')"
        >去调查</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('toRollFlow', '回到审核补充材料', 0)"
        >回到审核补充材料</el-button>
      </p>
      <p
        v-if="checkPermission('缴费:邮件通知立案', permList) && cases.flowCode == 100501"
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '邮件通知立案')"
        >邮件通知立案</el-button>
      </p>
      <p
        v-if="
          checkPermission('缴费:已发邮件通知缴费', permList) && cases.flowCode == 100510
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已发邮件通知缴费')"
        >已发邮件通知缴费</el-button>
      </p>
      <p v-if="checkPermission('缴费:回访', permList) && cases.flowCode == 100513">
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.UNOPERATING, '回访电话未接通')"
        >回访电话未接通</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.UNOPERATING, '回访电话未完成')"
        >未完成</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.NEXTSTEP, '已回访')"
        >已回访</el-button>
      </p>
      <p v-if="checkPermission('缴费:确认缴费', permList) && cases.flowCode == 100515">
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已缴费')"
        >已缴费</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('toRollFlow', '拒绝缴费', 0)"
        >拒绝缴费</el-button>
      </p>
      <p
        v-if="
          checkPermission('缴费:修改不予互助时间', permList) && cases.flowCode == 100520
        "
      >
        <el-date-picker
          v-model="startDeadlineTime"
          type="date"
          :readonly="true"
          disabled
          placeholder="开始不予互助时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
        <span style="margin: 0px 8px">-</span>
        <el-date-picker
          v-model="endDeadlineTime"
          type="date"
          placeholder="超时不予互助时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          style="margin-left: 10px"
          @click="updateDeadlineTime"
        >修改不予互助时间</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.REFUSAL, '不予互助')"
        >不予互助</el-button>
      </p>

      <!-- ******公估******-->
      <p v-if="checkPermission('公估:委派公估', permList) && cases.flowCode == 101005">
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('delegatedInfo')"
        >填写委派信息</el-button>
      </p>
      <p v-if="checkPermission('公估:接单确认', permList) && cases.flowCode == 101010">
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已经有调查人员接单')"
        >已经有调查人员接单</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.OVERTIME_RETURN, '接单超时，重新委派公估')"
        >接单超时，重新委派公估</el-button>
      </p>
      <p v-if="checkPermission('公估:回访', permList) && cases.flowCode == 101015">
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.UNOPERATING, '回访电话未接通')"
        >回访电话未接通</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="updateFlow(operateEnums.UNOPERATING, '回访电话未完成')"
        >未完成</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已回访')"
        >已回访</el-button>
      </p>
      <p
        v-if="checkPermission('公估:上传公估结果', permList) && cases.flowCode == 101020"
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '公估调查结果已上传')"
        >公估调查结果已上传</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('toRollFlow', '退回重新调查', 0)"
        >退回重新调查</el-button>
      </p>
      <!-- ***** 复审 *****-->
      <p
        v-if="checkPermission('复审:事件内容评估', permList) && cases.flowCode == 101501"
      >
        <!-- <el-button v-if="cases.hadPrevButton==true" type="primary" icon="el-icon-back" @click.stop="updateFlow(operateEnums.PREVIOUSFLOW,'上一步')" @click="showdrawerbox('contentAssessment')">上一步</el-button>
        <el-button type="primary" icon="iconfont icon-xiugai" @click="showdrawerbox('contentAssessment')">请评估</el-button>-->

        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '复审事件内容评估')"
        >下一步</el-button>
      </p>
      <p
        v-if="
          checkPermission('复审:审核公估调查内容', permList) && cases.flowCode == 101505
        "
      >
        <!-- <el-button v-if="cases.hadPrevButton==true" type="primary" icon="el-icon-back" @click.stop="updateFlow(operateEnums.PREVIOUSFLOW,'上一步')">上一步</el-button> -->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '说明公估结果', 'investigation')"
        >请说明公估结果</el-button>
        <!-- <el-button type="primary" icon="iconfont icon-xiugai" @click.prevent="updateFlow(operateEnums.NEXTSTEP,'复审审核公估调查内容')" >下一步</el-button> -->
      </p>
      <p
        v-if="
          checkPermission('复审:通知并查收补充资料:通知补充材料', permList) &&
            cases.flowCode == 101515
        "
      >
        <!-- <el-button v-if="cases.hadPrevButton==true" type="primary" icon="el-icon-back" @click.stop="updateFlow(operateEnums.PREVIOUSFLOW,'上一步')">上一步</el-button> -->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '复审:资料未完整，通知补充材料')"
        >资料未完整，通知补充材料</el-button>
      </p>
      <p
        v-if="
          checkPermission('复审:通知并查收补充资料:已收到材料', permList) &&
            cases.flowCode == 101520
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已收到材料')"
        >已收到材料</el-button>
      </p>
      <p
        v-if="
          checkPermission('复审:通知并查收补充资料:资料完整性', permList) &&
            cases.flowCode == 101525
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '资料完整')"
        >资料完整</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.CYCLE, '资料未完整')"
        >资料未完整</el-button>
      </p>
      <p
        v-if="checkPermission('复审:说明公估结果', permList) && cases.flowCode == 101530"
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '复审无需补充材料')"
        >无需补充材料</el-button>
      </p>
      <p
        v-if="checkPermission('复审:输出复审结果', permList) && cases.flowCode == 101535"
      >
        <!-- <el-button type="primary" icon="iconfont icon-xiugai" @click="updateFlow(operateEnums.NEXTSTEP,'审核通过')">审核通过</el-button>
					<el-button type="primary" icon="iconfont icon-xiugai" @click="updateFlow(operateEnums.WITHDRAWAL,'撤案')">撤案</el-button>
					<el-button type="primary" icon="iconfont icon-xiugai" @click="updateFlow(operateEnums.REFUSAL,'不予互助')">不予互助</el-button>
        <el-button type="primary" icon="iconfont icon-xiugai" @click="updateFlow(operateEnums.APPLICATION_COLLEGIATE,'申请合议')">申请合议</el-button>-->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '复审输出复审结果')"
        >下一步</el-button>
      </p>
      <p v-if="checkPermission('复审:合议', permList) && cases.flowCode == 101540">
        <el-input
          v-model="cases.collegiateResult"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10 }"
          placeholder="合议内容"
        />
        <br>
        <br>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="saveCollegiateResult"
        >保存</el-button>
      </p>
      <p v-if="checkPermission('复审:审批', permList) && cases.flowCode == 101550">
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '通过')"
        >通过</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('toRollFlow', '审批退回到复审结果', 0)"
        >退回到复审结果</el-button>
      </p>
      <p v-if="checkPermission('复审:三审', permList) && cases.flowCode == 101560">
        <!-- <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP,'通过')"
        >通过</el-button>

        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('toRollFlow','三审退回到复审结果',0)"
        >退回到复审结果</el-button>-->
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '通过')"
        >下一步</el-button>

        <el-button
          v-if="
            cases.lowerDegreeCommunicateStatus == false &&
              checkPermission('案件:修改案件锁定状态', permList)
          "
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateCaseLock(true)"
        >设为低度协谈</el-button>

        <el-button
          v-if="
            cases.lowerDegreeCommunicateStatus == true &&
              checkPermission('案件:修改案件锁定状态', permList)
          "
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateCaseLock(false)"
        >取消低度协谈</el-button>
      </p>
      <p v-if="checkPermission('复审:已审批', permList) && cases.flowCode == 101570">
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已审批')"
        >已审批</el-button>
      </p>

      <!--******** 交叉审 *****-->
      <p
        v-if="
          checkPermission('交叉审:事件内容评估', permList) && cases.flowCode == 101701
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('contentAssessment')"
        >请评估</el-button>
      </p>
      <p
        v-if="
          checkPermission('交叉审:审核公估调查内容', permList) && cases.flowCode == 101705
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('investigation')"
        >请说明公估结果</el-button>
      </p>
      <p
        v-if="
          checkPermission('交叉审:通知并查收补充资料:邮件通知补交', permList) &&
            cases.flowCode == 101715
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '资料未完整，通知补充材料')"
        >资料未完整，通知补充材料</el-button>
      </p>
      <p
        v-if="
          checkPermission('交叉审:通知并查收补充资料:已收到材料', permList) &&
            cases.flowCode == 101720
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已收到材料')"
        >已收到材料</el-button>
      </p>
      <p
        v-if="
          checkPermission('交叉审:通知并查收补充资料:修改不予互助时间', permList) &&
            cases.flowCode == 101722
        "
      >
        <el-date-picker
          v-model="startDeadlineTime"
          type="date"
          :readonly="true"
          disabled
          placeholder="开始不予互助时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
        <span style="margin: 0px 8px">-</span>
        <el-date-picker
          v-model="endDeadlineTime"
          type="date"
          placeholder="超时不予互助时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          style="margin-left: 10px"
          @click="updateDeadlineTime"
        >修改不予互助时间</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.REFUSAL, '不予互助')"
        >不予互助</el-button>
      </p>
      <p
        v-if="
          checkPermission('交叉审:通知并查收补充资料:资料完整性', permList) &&
            cases.flowCode == 101725
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '资料完整')"
        >资料完整</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.CYCLE, '资料未完整')"
        >资料未完整</el-button>
      </p>
      <p
        v-if="
          checkPermission('交叉审:说明公估结果', permList) && cases.flowCode == 101730
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '无需补充材料')"
        >无需补充材料</el-button>
      </p>

      <p
        v-if="
          checkPermission('交叉审:输出复审结果', permList) && cases.flowCode == 101735
        "
      >
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '审核通过')"
        >审核通过</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.WITHDRAWAL, '撤案')"
        >撤案</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.REFUSAL, '不予互助')"
        >不予互助</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.APPLICATION_COLLEGIATE, '申请合议')"
        >申请合议</el-button>
      </p>
      <p v-if="checkPermission('交叉审:合议', permList) && cases.flowCode == 101740">
        <el-input
          v-model="cases.perms"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10 }"
          placeholder="合议内容"
        />
        <br>
        <br>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '交叉审，合议保存')"
        >保存</el-button>
      </p>

      <!--******  待公示 *****-->
      <p v-if="cases.flowCode == 102001">
        <span v-if="checkPermission('待公示:退回', permList)" style="margin-right: 10px">
          <el-input
            v-model="cases.backRemark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
          />
          <br>
          <br>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CASEGOBACK, '退回')"
          >退回</el-button>
        </span>
        <el-button
          v-if="checkPermission('待公示:邮件告知用户', permList)"
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已发邮件通知会员提交相关资料')"
        >已发邮件通知会员提交相关资料</el-button>
      </p>
      <p v-if="cases.flowCode == 102005">
        <span v-if="checkPermission('待公示:退回', permList)" style="margin-right: 10px">
          <el-input
            v-model="cases.backRemark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
          />
          <br>
          <br>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CASEGOBACK, '退回')"
          >退回</el-button>
        </span>
        <span v-if="checkPermission('待公示:确认已缴费:缴费结果', permList)">
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.NEXTSTEP, '会员已缴费')"
          >会员已缴费</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.UNOPERATING, '挂起，会员未缴费')"
          >挂起，会员未缴费</el-button>
        </span>
      </p>
      <p
        v-if="
          checkPermission('待公示:确认已缴费:修改不予互助时间', permList) &&
            cases.flowCode == 102007
        "
      >
        <el-date-picker
          v-model="startDeadlineTime"
          type="date"
          :readonly="true"
          disabled
          placeholder="开始不予互助时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
        <span style="margin: 0px 8px">-</span>
        <el-date-picker
          v-model="endDeadlineTime"
          type="date"
          placeholder="超时不予互助时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          style="margin-left: 10px"
          @click="updateDeadlineTime"
        >修改不予互助时间</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.REFUSAL, '不予互助')"
        >不予互助</el-button>
      </p>
      <p v-if="cases.flowCode == 102010">
        <span v-if="checkPermission('待公示:退回', permList)" style="margin-right: 10px">
          <el-input
            v-model="cases.backRemark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
          />
          <br>
          <br>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CASEGOBACK, '退回')"
          >退回</el-button>
        </span>
        <span v-if="checkPermission('待公示:查收公证材料', permList)">
          <el-button
            v-if="cases.hadPrevButton == true"
            type="primary"
            icon="el-icon-back"
            @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
          >上一步</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.NEXTSTEP, '公证材料已收齐')"
          >公证材料已收齐</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.NEXTSTEP, '会员健在，无需提供')"
          >会员健在，无需提供</el-button>
        </span>
      </p>
      <p v-if="cases.flowCode == 102020">
        <span v-if="checkPermission('待公示:退回', permList)" style="margin-right: 10px">
          <el-input
            v-model="cases.backRemark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
          />
          <br>
          <br>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CASEGOBACK, '退回')"
          >退回</el-button>
        </span>
        <span v-if="checkPermission('待公示:核对银行账号:信息完整', permList)">
          <el-button
            v-if="cases.hadPrevButton == true"
            type="primary"
            icon="el-icon-back"
            @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
          >上一步</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.NEXTSTEP, '信息正确')"
          >信息正确</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CYCLE, '信息有误，需要更正')"
          >信息有误，需要更正</el-button>
        </span>
      </p>
      <p v-if="cases.flowCode == 102025">
        <span v-if="checkPermission('待公示:退回', permList)" style="margin-right: 10px">
          <el-input
            v-model="cases.backRemark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
          />
          <br>
          <br>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CASEGOBACK, '退回')"
          >退回</el-button>
        </span>
        <span v-if="checkPermission('待公示:核对银行账号:信息更正', permList)">
          <el-button
            v-if="cases.hadPrevButton == true"
            type="primary"
            icon="el-icon-back"
            @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
          >上一步</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.NEXTSTEP, '信息已更正')"
          >信息已更正</el-button>
        </span>
      </p>
      <p v-if="cases.flowCode == 102030">
        <span v-if="checkPermission('待公示:退回', permList)" style="margin-right: 10px">
          <el-input
            v-model="cases.backRemark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
          />
          <br>
          <br>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CASEGOBACK, '退回')"
          >退回</el-button>
        </span>
        <span v-if="checkPermission('待公示:回收调查意见表', permList)">
          <el-button
            v-if="cases.hadPrevButton == true"
            type="primary"
            icon="el-icon-back"
            @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
          >上一步</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.NEXTSTEP, '意见表已查收')"
          >意见表已查收</el-button>
        </span>
      </p>
      <p v-if="cases.flowCode == 102035">
        <span v-if="checkPermission('待公示:退回', permList)" style="margin-right: 10px">
          <el-input
            v-model="cases.backRemark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
          />
          <br>
          <br>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.CASEGOBACK, '退回')"
          >退回</el-button>
        </span>
        <span v-if="checkPermission('待公示:确认已完成助力', permList)">
          <el-button
            v-if="cases.hadPrevButton == true"
            type="primary"
            icon="el-icon-back"
            @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
          >上一步</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.NEXTSTEP, '已完成助力活动')"
          >已完成助力活动</el-button>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click="updateFlow(operateEnums.UNOPERATING, '挂起，等待完成助力活动')"
          >挂起，等待完成助力活动</el-button>
        </span>
      </p>
      <p v-if="cases.flowCode == 102070">
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '进入业管端')"
        >下一步</el-button>
      </p>
      <!--****  可公示 ******-->
      <p
        v-if="
          checkPermission('可公示:邮件通知用户进入公示期', permList) &&
            cases.flowCode == 102501
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已完成')"
        >已完成</el-button>
      </p>
      <p v-if="checkPermission('可公示:扣款', permList) && cases.flowCode == 102505">
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已完成')"
        >已完成</el-button>
      </p>
      <p v-if="checkPermission('可公示:收取收据', permList) && cases.flowCode == 102510">
        <el-button
          v-if="cases.hadPrevButton == true"
          type="primary"
          icon="el-icon-back"
          @click.stop="updateFlow(operateEnums.PREVIOUSFLOW, '上一步')"
        >上一步</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.NEXTSTEP, '已完成')"
        >已完成</el-button>
      </p>
      <!--****** 待归档：确认结果（待归档） *****-->
      <p v-if="cases.flowCode == 103001">
        <span v-if="checkPermission('待归档:确认结果', permList)">
          <div>
            <el-input
              v-model="cases.backRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="退回必填"
              style="margin-bottom: 15px"
            />
          </div>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            style="margin-right: 10px"
            @click.prevent="updateFlow(operateEnums.CASEGOBACK, '重新审核')"
          >重新审核</el-button>
          <el-button
            v-if="cases.processResultEnum != 'PROCESS'"
            type="primary"
            icon="iconfont icon-xiugai"
            @click.prevent="updateFlow(operateEnums.NEXTSTEP, '已发邮件通知会员审核结果')"
          >已发邮件通知会员审核结果</el-button>
          <!-- <el-button
            type="primary"
            v-if="cases.processResultEnum != 'PROCESS'"
            icon="iconfont icon-xiugai"
            @click.prevent="updateFlow(operateEnums.CYCLE, '去合议')"
            >去合议</el-button
          > -->
          <!-- <el-button type="primary" icon="iconfont icon-xiugai" v-if="cases.processResultEnum=='PROCESS'" @click.prevent="updateFlow(operateEnums.NEXTSTEP,'确认归档')">确认归档</el-button> -->
        </span>
      </p>
      <!-- ***************  待归档：合议  *************** -->
      <p v-if="cases.flowCode == '103050'">
        <!-- <span v-if="checkPermission('待归档:退回', permList)">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="退回必填"
            v-model="cases.backRemark"
            style="margin-bottom: 15px"
          ></el-input>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click.prevent="updateFlow(operateEnums.CASEGOBACK, '重新审核')"
            style="margin-right: 10px"
            >重新审核</el-button
          >
        </span> -->
        <span>
          <el-button
            type="primary"
            icon="iconfont icon-xiugai"
            @click.prevent="updateFlow(operateEnums.NEXTSTEP, '去法务')"
          >去法务</el-button>
        </span>
      </p>

      <!-- ***************  待归档：法务  *************** -->
      <!-- <p v-if="cases.flowCode == '103075'">
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.prevent="updateFlow(operateEnums.NEXTSTEP, '去归档')"
          >去归档</el-button
        >
      </p> -->

      <!-- ***************  归档(只有不予互助的才能重新发起) *****-->
      <p
        v-if="
          checkPermission('归档:归档', permList) &&
            cases.flowCode == 103501 &&
            cases.processResultEnum != 'PROCESS'
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.RESTARTCASE, '重新发起')"
        >退回到合议</el-button>
      </p>
      <!--****** 子任务 *****-->
      <p
        v-if="
          checkPermission('子任务:处理任务', permList) &&
            cases.taskIsShow == true &&
            taskCode != ''
        "
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateTask('MISSED_CALL', '未接通')"
        >未接通</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateTask('UNDONE', '未完成')"
        >未完成</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateTask('SKIP', '跳过')"
        >跳过</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateTask('DONE', '已完成')"
        >已完成</el-button>
      </p>
      <!--****** 中转站 *****-->
      <p
        v-if="
          checkPermission('案件中转站:移动案件', permList) &&
            cases.flowCode != 103001 &&
            cases.flowCode != 103501 &&
            cases.isStation == true
        "
        style="margin: 10px 0px"
      >
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('removeStation')"
        >取消中转</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('jumpFlow')"
        >跳到指定流程</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('repealCase')"
        >撤案</el-button>
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click="showdrawerbox('toFile')"
        >不予互助</el-button>
      </p>
      <!--****** 案件超期处理 *****-->
      <p
        v-if="
          cases.overTimeShowWithdrawFlag == true || cases.overTimeShowRefuseFlag == true
        "
        style="margin: 10px 0px"
      >
        <!-- 有不予互助的时候，不显示撤案 -->
        <el-button
          v-if="
            checkPermission('案件超期处理:撤案', permList) &&
              cases.overTimeShowWithdrawFlag == true &&
              cases.overTimeShowRefuseFlag != true
          "
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.WITHDRAWAL, '案件超期处理,撤案')"
        >撤案</el-button>
        <el-button
          v-if="
            checkPermission('案件超期处理:不予互助', permList) &&
              cases.overTimeShowRefuseFlag == true
          "
          type="primary"
          icon="iconfont icon-xiugai"
          @click="updateFlow(operateEnums.REFUSAL, '案件超期处理,不予互助')"
        >不予互助</el-button>
      </p>
    </div>
    <!-- ===============表单组件============== -->
    <router-view
      :cases="cases"
      :showdrawer="showdrawer"
      :drawer-type="drawerType"
      :button-name="buttonName"
      :perm-list="permList"
      :case-status="caseStatus"
      :remark-array="remarkArray"
      :remark="remark"
      @closedrawer="closedrawer"
      @getcaseInfo="getcaseInfo"
      @getImageByCaseCode="getImageByCaseCode('')"
    />

    <el-dialog
      title="委托调查链接列表"
      :visible.sync="linkListdialog"
      width="50%"
      custom-class="c-p"
    >
      <el-table border :data="links">
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
        />
        <el-table-column property="shareUrl" label="链接" />
        <el-table-column property="sharePwd" label="密码" width="100" />
        <el-table-column
          property="expireRemark"
          label="有效期"
          width="120"
        />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createLinks">生成链接</el-button>
        <el-button @click="linkListdialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="资料" :visible.sync="fileDialog" width="80%" custom-class="c-p">
      <!--*********************************************照片资料***************************************************-->
      <div id="imageInfo" class="image-info" style="margin-top: 25px">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="照片资料" name="caseFileViewer">
            <ul id="caseFileViewer" class="uploader_files case_detail_uploader_files">
              <li
                v-for="(item, index) in caseFilePicList"
                :key="index"
                class="uploader_file_block"
              >
                <div
                  v-if="
                    item.url.substr(-3).includes('doc') ||
                      item.url.substr(-4).includes('docx')
                  "
                >
                  <a :href="item.url" class="doc-class" />
                </div>
                <div v-else-if="item.url.substr(-3).includes('pdf')">
                  <a
                    :href="appPath + '/case/createPdfStream/?urlPath=' + item.url"
                    target="_blank"
                    class="pdf-class"
                  />
                </div>
                <div v-else-if="item.url.substr(-3).includes('mp3')">
                  <a :href="item.url" target="_blank" class="mp3-class" />
                </div>
                <div
                  v-else-if="checkVideo(item.url)"
                  style="max-width: 400px; max-height: 200px"
                >
                  <video
                    :preload="video.preload"
                    :poster="video.videoImg"
                    :height="video.height"
                    :width="video.width"
                    align="center"
                    :controls="video.controls"
                    :src="item.url"
                    mediatype="video"
                  >
                    <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                  </video>
                </div>
                <div
                  v-else-if="
                    item.url.substr(-3).includes('tif') ||
                      item.url.substr(-4).includes('tiff')
                  "
                  :id="'case_canvas_' + index"
                />

                <div v-else>
                  <img
                    alt
                    class="uploader_file"
                    :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                    :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                    @click="showImg('Annex')"
                  >
                </div>
                <span class="uploader_file_name">{{ item.name }}</span>
              </li>
            </ul>
          </el-tab-pane>

          <el-tab-pane
            v-if="checkPermission('纸质材料扫描件:查看', permList)"
            label="扫描件资料"
            name="scanFileViewer"
          >
            <div class="uploader_content">
              <ul id="scanFileViewer" class="uploader_files  case_detail_uploader_files">
                <el-checkbox-group
                  v-for="(item, index) in scanFilePicList"
                  :key="index"
                  v-model="tagTechnicalSelection"
                  class="uploader_file_block"
                >

                  <li>
                    <div
                      v-if="item.percentage < 100 && item.percentage > 0"
                      class="uploader_file "
                    >
                      <el-progress
                        type="circle"
                        :percentage="item.percentage"
                      />
                    </div>
                    <div v-else>
                      <span
                        class="uploader_file_del_icon"
                        @click.stop="delLi('scanFilePicList', index)"
                      >
                        <i class="el-icon-close" style="color: white" />
                      </span>
                      <div
                        v-if="
                          item.url.substr(-3).includes('doc') ||
                            item.url.substr(-4).includes('docx')
                        "
                      >
                        <a :href="item.url" class="doc-class" />
                      </div>
                      <div v-else-if="item.url.substr(-3).includes('pdf')">
                        <a
                          :href="appPath + '/case/createPdfStream/?urlPath=' + item.url"
                          target="_blank"
                          class="pdf-class"
                        />
                      </div>
                      <div v-else-if="item.url.substr(-3).includes('mp3')">
                        <a :href="item.url" target="_blank" class="mp3-class" />
                      </div>
                      <div
                        v-else-if="checkVideo(item.url)"
                        style="max-width: 400px; max-height: 200px"
                      >
                        <video
                          :preload="video.preload"
                          :poster="video.videoImg"
                          :height="video.height"
                          :width="video.width"
                          align="center"
                          :controls="video.controls"
                          :src="item.url"
                          mediatype="video"
                        />
                      </div>
                      <div
                        v-else-if="
                          item.url.substr(-3).includes('tif') ||
                            item.url.substr(-4).includes('tiff')
                        "
                        :id="'scan_canvas_' + index"
                        @click="showImg('PaperScan')"
                      />

                      <div v-else class="uploader_file">
                        <img
                          alt
                          :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                          :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                          @click="showImg('PaperScan')"
                        >
                      </div>

                    </div>
                    <span class="uploader_file_name">
                      <el-checkbox :key="item.url" :label="item" class="checkbox-block">
                        {{ convertFilesName("scanFilePicList", item.url, item.name) }}
                      </el-checkbox>
                    </span>

                  </li>
                </el-checkbox-group>
              </ul>

              <div class="uploader_file_uploader">
                <div class="uploader_input_wrp">
                  <i class="el-icon-plus" style="font-size: 28px" />
                  <input
                    type="file"
                    multiple="multiple"
                    class="uploader_input"
                    @change="chooseImage('scanFilePicList', $event)"
                  >
                </div>
              </div>
            </div>

            <div class="uploader_button">
              <el-button
                type="primary"
                icon="el-icon-upload"
                :loading="scanFileloading"
                :disabled="uploadingNum > 0"
                @click.stop="savePic('scanFilePicList')"
              >保存资料</el-button>

              <el-button
                type="primary"
                @click.stop="transferPic('scanFilePicList','PublicEstimate')"
              >转移到公示材料</el-button>

              <el-button
                type="primary"
                @click.stop="transferPic('scanFilePicList','CloseFile')"
              >转移到归档资料</el-button>

            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="checkPermission('公估调查结果:查看', permList)"
            label="公估调查资料"
            name="valuationFileViewer"
          >
            <div class="uploader_content">
              <ul
                id="valuationFileViewer"
                class="uploader_files case_detail_uploader_files"
              >
                <li
                  v-for="(item, index) in valuationFilePicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('valuationFilePicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>
                    <div
                      v-if="
                        item.url.substr(-3).includes('doc') ||
                          item.url.substr(-4).includes('docx')
                      "
                    >
                      <a :href="item.url" class="doc-class" />
                    </div>
                    <div v-else-if="item.url.substr(-3).includes('pdf')">
                      <a
                        :href="appPath + '/case/createPdfStream/?urlPath=' + item.url"
                        target="_blank"
                        class="pdf-class"
                      />
                    </div>
                    <div v-else-if="item.url.substr(-3).includes('mp3')">
                      <a :href="item.url" target="_blank" class="mp3-class" />
                    </div>
                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div
                      v-else-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'valuation_canvas_' + index"
                      @click="showImg('Valuation')"
                    />
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('Valuation')"
                      >
                    </div>
                  </div>

                  <span class="uploader_file_name">{{
                    convertFilesName("valuationFilePicList", item.url, item.name)
                  }}</span>
                </li>
              </ul>
              <div class="uploader_file_uploader">
                <div class="uploader_input_wrp">
                  <i class="el-icon-plus" style="font-size: 28px" />
                  <input
                    type="file"
                    multiple="multiple"
                    class="uploader_input"
                    @change="chooseImage('valuationFilePicList', $event)"
                  >
                </div>
              </div>
            </div>

            <div class="uploader_button">
              <el-button
                type="primary"
                icon="el-icon-upload"
                :loading="valuationFileloading"
                :disabled="uploadingNum > 0"
                @click.stop="savePic('valuationFilePicList')"
              >保存资料</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="checkPermission('公示资料:查看', permList)"
            label="公示资料"
            name="publicityFileViewer"
          >
            <div class="uploader_content">
              <ul
                id="publicityFileViewer"
                class="uploader_files case_detail_uploader_files"
              >
                <li
                  v-for="(item, index) in publicityFilePicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('publicityFilePicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>
                    <div
                      v-if="
                        item.url.substr(-3).includes('doc') ||
                          item.url.substr(-4).includes('docx')
                      "
                    >
                      <a :href="item.url" class="doc-class" />
                    </div>
                    <div v-else-if="item.url.substr(-3).includes('pdf')">
                      <a
                        :href="appPath + '/case/createPdfStream/?urlPath=' + item.url"
                        target="_blank"
                        class="pdf-class"
                      />
                    </div>
                    <div v-else-if="item.url.substr(-3).includes('mp3')">
                      <a :href="item.url" target="_blank" class="mp3-class" />
                    </div>
                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div
                      v-else-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'publicity_canvas_' + index"
                      @click="showImg('PublicEstimate')"
                    />
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('PublicEstimate')"
                      >
                    </div>
                  </div>
                  <span class="uploader_file_name">{{
                    convertFilesName("publicityFilePicList", item.url, item.name)
                  }}</span>
                </li>
              </ul>
              <div class="uploader_file_uploader">
                <div class="uploader_input_wrp">
                  <i class="el-icon-plus" style="font-size: 28px" />
                  <input
                    type="file"
                    multiple="multiple"
                    class="uploader_input"
                    @change="chooseImage('publicityFilePicList', $event)"
                  >
                </div>
              </div>
            </div>

            <div class="uploader_button">
              <el-button
                type="primary"
                icon="el-icon-upload"
                :loading="publicityFileloading"
                :disabled="uploadingNum > 0"
                @click.stop="savePic('publicityFilePicList')"
              >保存资料</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="checkPermission('归档资料:查看', permList)"
            label="归档资料"
            name="closeFileViewer"
          >
            <div class="uploader_content">
              <ul id="closeFileViewer" class="uploader_files case_detail_uploader_files">
                <li
                  v-for="(item, index) in closeFilePicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('closeFilePicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>
                    <div
                      v-if="
                        item.url.substr(-3).includes('doc') ||
                          item.url.substr(-4).includes('docx')
                      "
                    >
                      <a :href="item.url" class="doc-class" />
                    </div>
                    <div v-else-if="item.url.substr(-3).includes('pdf')">
                      <a
                        :href="appPath + '/case/createPdfStream/?urlPath=' + item.url"
                        target="_blank"
                        class="pdf-class"
                      />
                    </div>
                    <div v-else-if="item.url.substr(-3).includes('mp3')">
                      <a :href="item.url" target="_blank" class="mp3-class" />
                    </div>
                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div
                      v-else-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'close_canvas_' + index"
                      @click="showImg('CloseFile')"
                    />
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('CloseFile')"
                      >
                    </div>
                  </div>
                  <span class="uploader_file_name">{{
                    convertFilesName("closeFilePicList", item.url, item.name)
                  }}</span>
                </li>
              </ul>
              <div class="uploader_file_uploader">
                <div class="uploader_input_wrp">
                  <i class="el-icon-plus" style="font-size: 28px" />
                  <input
                    type="file"
                    multiple="multiple"
                    class="uploader_input"
                    @change="chooseImage('closeFilePicList', $event)"
                  >
                </div>
              </div>
            </div>

            <div class="uploader_button">
              <el-button
                type="primary"
                icon="el-icon-upload"
                :loading="closeFileloading"
                :disabled="uploadingNum > 0"
                @click.stop="savePic('closeFilePicList')"
              >保存资料</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="checkPermission('补充资料:查看', permList)"
            label="补充资料"
            name="allPhotoViewer"
          >
            <div class="uploader_content">
              <ul id="allPhotoViewer" class="uploader_files case_detail_uploader_files">
                <li
                  v-for="(item, index) in dailyPhotoPicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('dailyPhotoPicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>

                    <div
                      v-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'dailyPhoto_canvas_' + index"
                      @click="showImg('AddMaterial')"
                    />
                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('AddMaterial')"
                      >
                    </div>
                  </div>
                  <span class="uploader_file_name">{{
                    convertFilesName("dailyPhotoPicList", item.url, item.name)
                  }}</span>
                </li>
                <li
                  v-for="(item, index) in plainPhotoPicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('plainPhotoPicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>

                    <div
                      v-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'plainPhoto_canvas_' + index"
                      @click="showImg('AddMaterial')"
                    />
                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('AddMaterial')"
                      >
                    </div>
                  </div>
                  <span class="uploader_file_name">{{
                    convertFilesName("plainPhotoPicList", item.url, item.name)
                  }}</span>
                </li>
                <li
                  v-for="(item, index) in SMSPhotoPicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('SMSPhotoPicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>

                    <div
                      v-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'SMSPhoto_canvas_' + index"
                      @click="showImg('AddMaterial')"
                    />
                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('AddMaterial')"
                      >
                    </div>
                  </div>
                  <span class="uploader_file_name">{{
                    convertFilesName("SMSPhotoPicList", item.url, item.name)
                  }}</span>
                </li>
                <li
                  v-for="(item, index) in receiptPhotoPicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('receiptPhotoPicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>

                    <div
                      v-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'receiptPhoto_canvas_' + index"
                      @click="showImg('AddMaterial')"
                    />

                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('AddMaterial')"
                      >
                    </div>
                  </div>
                  <span class="uploader_file_name">{{
                    convertFilesName("receiptPhotoPicList", item.url, item.name)
                  }}</span>
                </li>
                <li
                  v-for="(item, index) in thankPhotoPicList"
                  :key="index"
                  class="uploader_file_block"
                >
                  <div
                    v-if="item.percentage < 100 && item.percentage > 0"
                    class="uploader_file"
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                    />
                  </div>
                  <div v-else>
                    <span
                      class="uploader_file_del_icon"
                      @click.stop="delLi('thankPhotoPicList', index)"
                    >
                      <i class="el-icon-close" style="color: white" />
                    </span>

                    <div
                      v-if="
                        item.url.substr(-3).includes('tif') ||
                          item.url.substr(-4).includes('tiff')
                      "
                      :id="'thankPhoto_canvas_' + index"
                      @click="showImg('AddMaterial')"
                    />
                    <div
                      v-else-if="checkVideo(item.url)"
                      style="max-width: 400px; max-height: 200px"
                    >
                      <video
                        :preload="video.preload"
                        :poster="video.videoImg"
                        :height="video.height"
                        :width="video.width"
                        align="center"
                        :controls="video.controls"
                        :src="item.url"
                        mediatype="video"
                      >
                        <!-- <source :src="item.url" :type="videoType(item.url)"> -->
                      </video>
                    </div>
                    <div v-else class="uploader_file">
                      <img
                        alt
                        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
                        @click="showImg('AddMaterial')"
                      >
                    </div>
                  </div>
                  <span class="uploader_file_name">{{
                    convertFilesName("thankPhotoPicList", item.url, item.name)
                  }}</span>
                </li>
              </ul>
            </div>

            <div class="uploader_button">
              <el-button
                type="primary"
                icon="el-icon-upload"
                :loading="allPhotoloading"
                :disabled="uploadingNum > 0"
                @click.stop="savePic('allPhotoPicList')"
              >保存资料</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fileDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="历史处理记录"
      :visible.sync="historyDialog"
      width="70%"
      custom-class="c-p"
    >
      <!--*************************历史记录********************************************************-->
      <div>
        <div v-if="operationList.length == 0" class="none">
          <p>暂无</p>
        </div>
        <div
          v-if="operationList.length > 0"
          class="operat-list"
          style="height: 300px; overflow-y: auto"
        >
          <el-timeline :reverse="false" style="margin-left: 5px">
            <el-timeline-item v-for="(item, index) in operationList" :key="index">
              <div>
                {{ item.flow_name }}
                <span v-if="item.remark != null">
                  备注：
                  <span
                    class="el-link el-link--primary"
                    style="margin-top: -3px"
                    @click="showHistory(index)"
                  >查看</span>
                </span>
                <span v-if="item.ruleAnswerContent != null">
                  告知规则备注：
                  <span
                    class="el-link el-link--primary"
                    style="margin-top: -3px"
                    @click="showRuleAnswerContent(index)"
                  >查看</span>
                </span>
              </div>
              <p>
                {{ item.operate_time }}
                <span style="margin-left: 15px">操作账号: {{ item.account_number }}</span>
              </p>
            </el-timeline-item>
          </el-timeline>
        </div>
        <!-- <div v-if="operationList.length > 3">
					<el-divider v-if="!isshow" class="cursor" @click="slide(2)">收起 <i class="el-icon-arrow-up"></i></el-divider>
					<el-divider  v-if="isshow" class="cursor" @click="slide(1)">展开 <i class="el-icon-arrow-down"></i></el-divider>
        </div>-->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="historyDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="发送邮件"
      :visible.sync="emailDialog"
      width="90%"
      custom-class="c-p"
    >
      <sendEmail
        :case-code="cases.caseCode"
        :version="cases.infoVersion"
        :cases="cases"
        :update-t="showButton"
        :show-email-tab="showEmailTab"
        :show-email-msg="showEmailMsg"
        :show-email-code="showEmailCode"
        :perm-list="permList"
        @updateFlow="updateCaseFlow"
        @getcaseInfo="getcaseInfo"
      />
    </el-dialog>
    <el-dialog
      title="费用计算"
      :visible.sync="calcHelpMoneyDialog"
      width="350px"
      custom-class="c-p"
    >
      <div>
        <div class="search-con-item">
          <label style="width: 70px" class="search-con-item__label">治疗总额:</label>
          <span>
            <el-input
              v-model="cases.cureTotal"
              placeholder="治疗总额"
              @change="changeHelpMoney"
              @input="onChangeCureTotal"
            />元
          </span>
        </div>
        <div class="search-con-item">
          <label style="width: 70px" class="search-con-item__label">社保报销:</label>
          <span>
            <el-input
              v-model="cases.socialSecurityExpense"
              placeholder="社保报销"
              @change="changeHelpMoney"
            />元
          </span>
        </div>
        <div class="search-con-item">
          <label style="width: 70px" class="search-con-item__label">第三方报销:</label>
          <span>
            <el-input
              v-model="cases.thirdPartyExpense"
              placeholder="第三方报销"
              @change="changeHelpMoney"
            />元
          </span>
        </div>
        <div class="search-con-item">
          <label style="width: 70px" class="search-con-item__label">互助金额:</label>
          <span>{{ cases.mutualMoney }}元</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCalculateHelpMoney">确定</el-button>
        <el-button @click="rollbackCalcHelpMoney">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="checkUrlStatus" width="450px" append-to-body @open="doCopy">
      <el-input
        v-model="checkUrl"
        style="width: 300px; margin-right: 5px"
        disabled
      />
      <el-button type="button" @click="doCopy">点击复制</el-button>

      <span slot="footer" class="dialog-footer">
        <el-button @click="checkUrlStatus = false">取 消</el-button>
        <el-button type="primary" @click="checkUrlStatus = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import common from '@/utils/common'
import ruleItem from './components/rule_item.vue'
import answerItem from '@/pages/caseDetailV2/components/answerItem/index'
import communicationMoreInfo from './components/CommunicationMoreInfo.vue'
import SendEmail from '@/pages/email/SendEmail.vue'
export default {
  components: {
    ruleItem,
    answerItem,
    communicationMoreInfo,
    SendEmail
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      applyloading: false,
      abstractloading: false,

      cases: {},
      tagTechnicalSelection: [],
      appPath: this.homePath(),
      linkListdialog: false,
      links: [], // 委托调查链接列表
      showdrawer: false,
      drawerType: '',
      caseStatus: '',
      buttonName: '', // 按钮说明
      remark: '',
      checkUrl: '',
      checkUrlStatus: false,
      remarkArray: [],
      startDeadlineTime: null, // 超时不予互助时使用的时间
      endDeadlineTime: null,
      diseaseList: [],
      accidentTypeList: [],
      testItem: [],
      ruleResult: [],
      answerList: [],
      suspectCommunicateInfos: [],
      state: '',
      sysAdviseDegreeType: '',
      nginxServerData: [],
      calcHelpMoneyDialog: false,
      calcHelpMoneyBak: {},
      diseaseProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      },
      tnmList: [
        { code: 100000, name: 'TX', parentCode: 0 },
        { code: 100100, name: 'NX', parentCode: 100000 },
        { code: 100101, name: 'TXNXM0', parentCode: 100100 },
        { code: 100102, name: 'TXNXM1', parentCode: 100100 },
        { code: 100200, name: 'N0', parentCode: 100000 },
        { code: 100201, name: 'TXN0M0', parentCode: 100200 },
        { code: 100202, name: 'TXN0M1', parentCode: 100200 },
        { code: 100300, name: 'N1', parentCode: 100000 },
        { code: 100301, name: 'TXN1M0', parentCode: 100300 },
        { code: 100302, name: 'TXN1M1', parentCode: 100300 },
        { code: 100400, name: 'N2', parentCode: 100000 },
        { code: 100401, name: 'TXN2M0', parentCode: 100400 },
        { code: 100402, name: 'TXN2M1', parentCode: 100400 },
        { code: 100500, name: 'N3', parentCode: 100000 },
        { code: 100501, name: 'TXN3M0', parentCode: 100500 },
        { code: 100502, name: 'TXN3M1', parentCode: 100500 },

        { code: 110000, name: 'T0', parentCode: 0 },
        { code: 110100, name: 'NX', parentCode: 110000 },
        { code: 110101, name: 'T0NXM0', parentCode: 110100 },
        { code: 110102, name: 'T0NXM1', parentCode: 110100 },
        { code: 110200, name: 'N0', parentCode: 110000 },
        { code: 110201, name: 'T0N0M0', parentCode: 110200 },
        { code: 110202, name: 'T0N0M1', parentCode: 110200 },
        { code: 110300, name: 'N1', parentCode: 110000 },
        { code: 110301, name: 'T0N1M0', parentCode: 110300 },
        { code: 110302, name: 'T0N1M1', parentCode: 110300 },
        { code: 110400, name: 'N2', parentCode: 110000 },
        { code: 110401, name: 'T0N2M0', parentCode: 110400 },
        { code: 110402, name: 'T0N2M1', parentCode: 110400 },
        { code: 110500, name: 'N3', parentCode: 110000 },
        { code: 110501, name: 'T0N3M0', parentCode: 110500 },
        { code: 110502, name: 'T0N3M1', parentCode: 110500 },

        { code: 120000, name: 'Tis', parentCode: 0 },
        { code: 120100, name: 'NX', parentCode: 120000 },
        { code: 120101, name: 'TisNXM0', parentCode: 120100 },
        { code: 120102, name: 'TisNXM1', parentCode: 120100 },
        { code: 120200, name: 'N0', parentCode: 120000 },
        { code: 120201, name: 'TisN0M0', parentCode: 120200 },
        { code: 120202, name: 'TisN0M1', parentCode: 120200 },
        { code: 120300, name: 'N1', parentCode: 120000 },
        { code: 120301, name: 'TisN1M0', parentCode: 120300 },
        { code: 120302, name: 'TisN1M1', parentCode: 120300 },
        { code: 120400, name: 'N2', parentCode: 120000 },
        { code: 120401, name: 'TisN2M0', parentCode: 120400 },
        { code: 120402, name: 'TisN2M1', parentCode: 120400 },
        { code: 120500, name: 'N3', parentCode: 120000 },
        { code: 120501, name: 'TisN3M0', parentCode: 120500 },
        { code: 120502, name: 'TisN3M1', parentCode: 120500 },

        { code: 130000, name: 'T1', parentCode: 0 },
        { code: 130100, name: 'NX', parentCode: 130000 },
        { code: 130101, name: 'T1NXM0', parentCode: 130100 },
        { code: 130102, name: 'T1NXM1', parentCode: 130100 },
        { code: 130200, name: 'N0', parentCode: 130000 },
        { code: 130201, name: 'T1N0M0', parentCode: 130200 },
        { code: 130202, name: 'T1N0M1', parentCode: 130200 },
        { code: 130300, name: 'N1', parentCode: 130000 },
        { code: 130301, name: 'T1N1M0', parentCode: 130300 },
        { code: 130302, name: 'T1N1M1', parentCode: 130300 },
        { code: 130400, name: 'N2', parentCode: 130000 },
        { code: 130401, name: 'T1N2M0', parentCode: 130400 },
        { code: 130402, name: 'T1N2M1', parentCode: 130400 },
        { code: 130500, name: 'N3', parentCode: 130000 },
        { code: 130501, name: 'T1N3M0', parentCode: 130500 },
        { code: 130502, name: 'T1N3M1', parentCode: 130500 },

        { code: 140000, name: 'T2', parentCode: 0 },
        { code: 140100, name: 'NX', parentCode: 140000 },
        { code: 140101, name: 'T2NXM0', parentCode: 140100 },
        { code: 140102, name: 'T2NXM1', parentCode: 140100 },
        { code: 140200, name: 'N0', parentCode: 140000 },
        { code: 140201, name: 'T2N0M0', parentCode: 140200 },
        { code: 140202, name: 'T2N0M1', parentCode: 140200 },
        { code: 140300, name: 'N1', parentCode: 140000 },
        { code: 140301, name: 'T2N1M0', parentCode: 140300 },
        { code: 140302, name: 'T2N1M1', parentCode: 140300 },
        { code: 140400, name: 'N2', parentCode: 140000 },
        { code: 140401, name: 'T2N2M0', parentCode: 140400 },
        { code: 140402, name: 'T2N2M1', parentCode: 140400 },
        { code: 140500, name: 'N3', parentCode: 140000 },
        { code: 140501, name: 'T2N3M0', parentCode: 140500 },
        { code: 140502, name: 'T2N3M1', parentCode: 140500 },

        { code: 150000, name: 'T3', parentCode: 0 },
        { code: 150100, name: 'NX', parentCode: 150000 },
        { code: 150101, name: 'T3NXM0', parentCode: 150100 },
        { code: 150102, name: 'T3NXM1', parentCode: 150100 },
        { code: 150200, name: 'N0', parentCode: 150000 },
        { code: 150201, name: 'T3N0M0', parentCode: 150200 },
        { code: 150202, name: 'T3N0M1', parentCode: 150200 },
        { code: 150300, name: 'N1', parentCode: 150000 },
        { code: 150301, name: 'T3N1M0', parentCode: 150300 },
        { code: 150302, name: 'T3N1M1', parentCode: 150300 },
        { code: 150400, name: 'N2', parentCode: 150000 },
        { code: 150401, name: 'T3N2M0', parentCode: 150400 },
        { code: 150402, name: 'T3N2M1', parentCode: 150400 },
        { code: 150500, name: 'N3', parentCode: 150000 },
        { code: 150501, name: 'T3N3M0', parentCode: 150500 },
        { code: 150502, name: 'T3N3M1', parentCode: 150500 },

        { code: 160000, name: 'T4', parentCode: 0 },
        { code: 160100, name: 'NX', parentCode: 160000 },
        { code: 160101, name: 'T4NXM0', parentCode: 160100 },
        { code: 160102, name: 'T4NXM1', parentCode: 160100 },
        { code: 160200, name: 'N0', parentCode: 160000 },
        { code: 160201, name: 'T4N0M0', parentCode: 160200 },
        { code: 160202, name: 'T4N0M1', parentCode: 160200 },
        { code: 160300, name: 'N1', parentCode: 160000 },
        { code: 160301, name: 'T4N1M0', parentCode: 160300 },
        { code: 160302, name: 'T4N1M1', parentCode: 160300 },
        { code: 160400, name: 'N2', parentCode: 160000 },
        { code: 160401, name: 'T4N2M0', parentCode: 160400 },
        { code: 160402, name: 'T4N2M1', parentCode: 160400 },
        { code: 160500, name: 'N3', parentCode: 160000 },
        { code: 160501, name: 'T4N3M0', parentCode: 160500 },
        { code: 160502, name: 'T4N3M1', parentCode: 160500 }
      ],
      tnmTreeList: [],
      tnmProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      },
      chareTypeList: [],
      surveyPayResult: '',
      kyhzType: [
        { code: 0, name: '未选择' },
        { code: 1, name: '低度' },
        { code: 2, name: '一般' }
      ],
      ywhzType: [
        { code: 0, name: '未选择' },
        { code: 1, name: '一般意外' },
        { code: 2, name: '高风险意外' }
      ],
      lifeTrack: [
        { code: 0, name: '未选择' },
        { code: 2, name: '3个地区以下' },
        { code: 1, name: '3个地区及以上' }
      ],
      hiddenDiseaseHistory: [
        { code: 0, name: '未选择' },
        { code: 1, name: '存在隐瞒病史及体检情况、伪造病历资料、公证书等情况' },
        {
          code: 2,
          name: '不存在隐瞒病史及体检情况、伪造病历资料、公证书等情况'
        }
      ],
      thirdPartyInsurance: [
        { code: 0, name: '未选择' },
        { code: 2, name: '总保额小于100万' },
        { code: 1, name: '总保额大于100万（含）' }
      ],
      riskAppend: [
        { code: 0, name: '未选择' },
        { code: 1, name: '会员/推荐人/家庭成员从事保险、公估、医护工作' },
        { code: 2, name: '并非从事保险、公估、医护工作' }
      ],
      isType: [
        { name: '请选择', code: -1 },
        { name: '是', code: 1 },
        { name: '否', code: 0 }
      ],
      riskMovementType: [
        { name: '请选择', code: 0 },
        { name: '潜水', code: 1 },
        { name: '滑水', code: 2 },
        { name: '滑雪', code: 3 },
        { name: '滑冰', code: 4 },
        { name: '驾驶或乘坐滑翔翼、滑翔伞', code: 5 },
        { name: '跳伞', code: 6 },
        { name: '攀岩运动', code: 7 },
        { name: '探险活动', code: 8 },
        { name: '武术比赛', code: 9 },
        { name: '摔跤比赛', code: 10 },
        { name: '柔道', code: 11 },
        { name: '空手道', code: 12 },
        { name: '跆拳道', code: 13 },
        { name: '马术', code: 14 },
        { name: '拳击', code: 15 },
        { name: '特技表演', code: 16 },
        { name: '驾驶卡丁车', code: 17 },
        { name: '赛马', code: 18 },
        { name: '赛车', code: 19 },
        { name: '各种车辆表演', code: 20 },
        { name: '蹦极', code: 21 },
        { name: '其他', code: 22 }
      ],
      riskJobType: [
        { name: '请选择', code: 0 },
        {
          name:
            '从事建筑工程工作人员（包括但不限于建筑施工工人、建筑工程车辆驾驶或机械操作员、工地管理人员及临时工作人员）；',
          code: 1
        },
        {
          name: '涉及或接触任何危险物（化学物质、爆炸物、有毒物质等）的作业人员；',
          code: 2
        },
        { name: '从事煤炭生产、油矿开采业作业人员；', code: 3 },
        { name: '高压电或带电作业人员；', code: 4 },
        { name: '从事烟花爆竹生产、冶金、机械制造工作人员；', code: 5 },
        {
          name:
            '现役军警人员中的地面部队、海军陆战队、水兵、空军飞行员、前线军人、特种部队人员，或防爆警、刑警、消防队员、武器装备研制生产与试验（含民用航空及核燃料）人员；',
          code: 6
        },
        { name: '从事交通运输的驾驶员及随车辅助人员', code: 7 },
        { name: '从事高风险运动的运动员、教练员、陪练员', code: 8 },
        { name: '战地记者', code: 9 }
      ],
      riskTaskType: [
        { name: '请选择', code: 0 },
        { name: '设备检修作业', code: 1 },
        { name: '电气作业', code: 2 },
        { name: '热工作业', code: 3 },
        { name: '进入受限空间作业', code: 4 },
        { name: '挖掘作业', code: 5 },
        { name: '起重作业', code: 6 },
        { name: '高处作业', code: 7 },
        { name: '接触危险化学品作业', code: 8 }
      ],
      abstractList: [], // 摘要列表
      abstract: {
        // 摘要对象
        caseCode: '',
        content: ''
      },
      imageTypes: ['mp4', 'wma', 'mpeg', 'avi', 'mov', 'flv', 'f4v', 'rmvb', 'mp3'],

      disabled: false,
      caseFilePicList: [], // 案件资料
      caseFileViewer: null,
      scanFilePicList: [], // 扫描件资料
      scanFileViewer: null,
      valuationFilePicList: [], // 公估调查结果资料
      valuationFileViewer: null,
      publicityFilePicList: [], // 公示资料
      publicityFileViewer: null,
      closeFilePicList: [], // 归档资料
      closeFileViewer: null,
      createCasePicList: [], // 创建案件的图片列表
      createCaseViewer: null,
      allPhotoPicList: [], // 所有补充资料照片
      allPhotoViewer: null,
      dailyPhotoPicList: [], // 日常照
      plainPhotoPicList: [], // 计划照
      SMSPhotoPicList: [], // 短信照
      receiptPhotoPicList: [], // 收据照
      thankPhotoPicList: [], // 感谢照
      delList: {
        AddMaterialDailyPhoto: [],
        AddMaterialPlainPhoto: [],
        AddMaterialSMSPhoto: [],
        AddMaterialReceiptPhoto: [],
        AddMaterialThankPhoto: []
      },
      uploadLoading: false,
      scanFileloading: false,
      valuationFileloading: false,
      publicityFileloading: false,
      closeFileloading: false,
      allPhotoloading: false,
      historyDialog: false,
      fileDialog: false,
      emailDialog: false,
      showEmailTab: [],
      showEmailCode: 0,
      showButton: false,
      showEmailMsg: '',
      operationList: [], // 操作历史记录列表
      isshow: true,
      minHeight: '240px',
      historyData: null,
      healthyDetail: [],
      checked: true,
      operateEnums: {
        WITHDRAWAL: 1, // 撤案
        REFUSAL: 2, // 不予互助
        PREVIOUSFLOW: 4, // 上一步
        CASEGOBACK: 8, // 回退
        APPLICATION_COLLEGIATE: 16, // 申请合议
        NEXTSTEP: 32, // 下一步
        RESTARTCASE: 64, // 重新发起
        CYCLE: 128, // 循环
        UNOPERATING: 256, // 不做操作
        OVERTIME_RETURN: 512 // 超时退回
      },
      // trailResult: null, //初审审核结果
      bucketName: '',
      region: '',
      secretId: '',
      secretKey: '',
      taskCode: '', // 任务数据
      taskVersion: '', // 任务数据
      isshowMovecase: false,
      uploadingNum: 0,
      answerRuleResult: {},
      activeName: 'caseFileViewer',
      video: {
        videoImg:
          'http://ehuzhu-1251082375.cos.ap-guangzhou.myqcloud.com/cms/7c6c9485913cc8c91ae8.png',
        playStatus: '',
        muteStatus: '',
        isMute: true,
        isPlay: false,
        width: '125', // 设置视频播放器的显示宽度（以像素为单位）
        height: '125', // 设置视频播放器的显示高度（以像素为单位）
        preload: 'auto', //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        controls: true // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      }
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    /**
     * 获取抗癌计划-互助标准对应的名称
     */
    getKyMutualStandardName() {
      const { kyhzType } = this
      const { kyMutualStandard } = this.cases
      let name = ''

      kyhzType &&
        kyhzType.forEach((item) => {
          if (item.code === kyMutualStandard) {
            name = item.name
          }
        })

      return name
    },

    /**
     * 获取意外计划-互助标准对应的名称
     */
    getYwMutualStandardName() {
      const { ywhzType } = this
      const { ywMutualStandard } = this.cases
      let name = ''

      ywhzType &&
        ywhzType.forEach((item) => {
          if (item.code === ywMutualStandard) {
            name = item.name
          }
        })

      return name
    }
  },

  created() {
    this.$emit('setCurrentMenu', '案件详情')
    this.getcaseInfo()
    this.tnmTreeList = this.filterNull(
      this.toTreeData(this.tnmList, 'parentCode', 'code')
    )
  },

  methods: {
    transferPic(type, target) {
      if (this.tagTechnicalSelection.length === 0) {
        this.$alert('请选择数据', '提示')
        return
      }
      const attachmentList = {}
      if (type === 'scanFilePicList') {
        attachmentList['PaperScan'] = this.tagTechnicalSelection
      }

      const attm = {
        caseCode: this.cases.caseCode,
        attachmentType: target,
        attachmentList: attachmentList,
        delList: {}
      }
      this.axios
        .put(this.homePath() + '/casesCommon/transferPic', attm)
        .then((res) => {
          if (res.data.status === '000000') {
            this.tagTechnicalSelection = []

            this.$alert('保存成功', '提示')
            this.getImageByCaseCode('') // 加载照片资料
          } else {
            this.$alert(res.data.msg, '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    updateCaseLock(status) {
      const params = {
        caseCode: this.cases.caseCode,
        caseLockStatus: 1,
        detailVersion: this.cases.detailVersion,
        doLockFlag: status
      }
      this.axios
        .post(this.homePath() + '/case-lock/update', params)
        .then((res) => {
          if (res.data.status === '000000') {
            if (!status) {
              this.$alert('取消低度协谈标识成功，请再次确认互助标准', '提示')
            }
            this.getcaseInfo()
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    checkVideo(url) {
      const type = url.substring(url.lastIndexOf('.') + 1, url.length)
      return this.imageTypes.indexOf(type) !== -1
    },
    back() {
      const currentfrom = this.$route.query.from
      if (currentfrom === 'todo') {
        this.$router.push({
          path: '/index/todoCase',
          query: {
            from: 'casedetail'
          }
        })
      } else if (currentfrom === 'all') {
        this.$router.push({
          path: '/index/allcase',
          query: {
            from: 'casedetail'
          }
        })
      } else if (currentfrom === 'overtime') {
        this.$router.push({
          path: '/index/overtimeCase',
          query: {
            from: 'casedetail'
          }
        })
      } else if (currentfrom === 'task') {
        this.$router.push({
          path: '/index/task'
        })
      } else if (currentfrom === 'mytask') {
        this.$router.push({
          path: '/index/mytask'
        })
      } else if (currentfrom === 'myemail') {
        this.$router.push({
          path: '/index/myemail'
        })
      } else {
        this.$router.push({
          path: '/index/allcase'
        })
      }
    },
    sendEmail() {
      this.$router.push(
        '/index/sendemail/' + this.cases.caseCode + '/' + this.cases.flowCode
      )
    },
    moreInfo() {
      this.$router.push('/index/moreinfo/' + this.cases.caseCode)
    },
    changeCaseInfo() {
      this.$router.push('/index/changecase/' + this.cases.caseCode)
    },
    moveCase(operation, remark) {
      const params = {
        caseCode: this.cases.caseCode,
        operation: operation,
        remark: remark
      }
      this.axios
        .post(this.homePath() + '/case-station/changeStation/', params)
        .then((res) => {
          if (res.data.status === '000000') {
            this.$alert('操作成功', '提示', {
              callback: (action) => {
                this.getcaseInfo()
              }
            })
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    showdrawerbox(type, buttonName, caseStatus) {
      this.showdrawer = true
      this.drawerType = type
      this.buttonName = buttonName
      this.caseStatus = caseStatus
    },

    closedrawer(close) {
      this.showdrawer = close
    },

    getcaseInfo() {
      const caseCode = this.$route.params.caseCode
      this.cases.caseCode = caseCode

      this.axios
        .get(this.homePath() + '/case-info/information/' + caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            this.cases = res.data.data
            if (res.data.data.sendTimeStr !== undefined) {
              this.startDeadlineTime = res.data.data.sendTimeStr
            }
            if (res.data.data.sendTimeStr !== undefined) {
              this.endDeadlineTime = res.data.data.endTimeStr
            }

            if (res.data.data.productName.substring(0, 2) === '意外') {
              this.getaccidentTypeList() // 加载当前事故类型
            } else {
              this.getdiseaseList() // 加载部位器官诊断信息
            }

            this.getImageByCaseCode('') // 加载照片资料
            this.getCaseAbstractList() // 加载摘要
            this.getCaseOperationList() // 加载操作历史

            // 如果是初审最终子流程，发起取审核结果
            // if ((this.cases.flowCode + "").substring(0, 4) == "1000") {
            //   this.getCalcTrailResult();
            // }

            // 如果是少儿互助计划-则计算互助金额
            if (
              this.cases.diseaseIcdInfo !== undefined &&
              this.cases.diseaseIcdInfo !== null &&
              this.cases.diseaseIcdInfo.degreeType === 1
            ) {
              this.changeHelpMoney()
            }

            // this.getChargeType(); //加载支付信息
            this.getCalcSurveyPay(true) // 加载收费类型

            this.getCosInfo()

            this.getTaskInfo() // 加载任务信息
            this.getCaseRuleAnswerList()
            this.getCaseRuleSuspectList()
            this.getCalcCaseRuleResult()
            this.riskChange()
          } else {
            this.$alert(res.data.message, '提示', {
              callback: (action) => {
                this.$router.push('/index/allcase')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    doCopy() {
      var that = this
      this.$copyText(this.checkUrl).then(
        function(e) {
          that.$message({ type: 'success', message: '内容已复制到剪切板！' })
        },
        function(e) {
          that.$message({
            type: 'warning',
            message: '该浏览器不支持自动复制,请手动点击复制'
          })
        }
      )
    },
    copyCheckUrl() {
      // 查询
      this.checkUrl = ''
      const caseCode = this.$route.params.caseCode
      this.axios
        .get(this.homePath() + '/applicant-wx-check/token/' + caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            this.checkUrl = res.data.data.url
            this.checkUrlStatus = true
          } else {
            this.$alert('获取验证链接失败！', '提示')
          }
        })
    },
    handleClick(tab) {
      this.tagTechnicalSelection = []
      if (tab.name === 'caseFileViewer') {
        for (let i = 0; i < this.caseFilePicList.length; i++) {
          this.tiffImage(this.caseFilePicList[i].url, 'case_canvas_' + i)
        }
      } else if (tab.name === 'publicityFileViewer') {
        for (let i = 0; i < this.publicityFilePicList.length; i++) {
          this.tiffImage(this.publicityFilePicList[i].url, 'publicity_canvas_' + i)
        }
      } else if (tab.name === 'valuationFileViewer') {
        for (let i = 0; i < this.valuationFilePicList.length; i++) {
          this.tiffImage(this.valuationFilePicList[i].url, 'valuation_canvas_' + i)
        }
      } else if (tab.name === 'closeFileViewer') {
        for (let i = 0; i < this.closeFilePicList.length; i++) {
          this.tiffImage(this.closeFilePicList[i].url, 'close_canvas_' + i)
        }
      } else if (tab.name === 'scanFileViewer') {
        for (let i = 0; i < this.scanFilePicList.length; i++) {
          this.tiffImage(this.scanFilePicList[i].url, 'scan_canvas_' + i)
        }
      } else if (tab.name === 'allPhotoViewer') {
        for (let i = 0; i < this.dailyPhotoPicList.length; i++) {
          this.tiffImage(this.dailyPhotoPicList[i].url)
        }
        for (let i = 0; i < this.plainPhotoPicList.length; i++) {
          this.tiffImage(this.plainPhotoPicList[i].url, 'plainPhoto_canvas_' + i)
        }
        for (let i = 0; i < this.SMSPhotoPicList.length; i++) {
          this.tiffImage(this.SMSPhotoPicList[i].url, 'SMSPhoto_canvas_' + i)
        }

        for (let i = 0; i < this.receiptPhotoFilePicList.length; i++) {
          this.tiffImage(this.receiptPhotoFilePicList[i].url, 'receiptPhoto_canvas_' + i)
        }
        for (let i = 0; i < this.thankPhotoPicList.length; i++) {
          this.tiffImage(this.thankPhotoPicList[i].url, 'thankPhoto_canvas_' + i)
        }
      }
    },
    setTif({ canvas, id }) {
      document.getElementById(id).append(canvas)
    },
    tiffImage(url, id) {
      if (document.getElementById(id) !== null) {
        const tag = document.getElementById(id).getElementsByTagName('canvas')
        if (tag.length === 1) {
          return
        }
      }

      if (common.hasTiff(url)) {
        this.$nextTick(() => {
          common.getTif({ url: url, w: 125, h: 125, isScale: true }).then((res) => {
            if (res) {
              this.setTif({ canvas: res, id })
            }
          })
        })
      }
    },

    getImageByCaseCode(imageType) {
      // 获取案件图片资料
      const vm = this
      const caseCode = vm.cases.caseCode
      vm.axios
        .get(
          vm.homePath() +
            '/casesCommon/getImageByCaseCode?imageType=' +
            imageType +
            '&caseCode=' +
            caseCode
        )
        .then((res) => {
          const resData = res.data
          if (resData.status === '000000') {
            if (resData.result != null) {
              if (resData.result.Annex !== undefined) {
                // 案件资料
                vm.caseFilePicList = resData.result.Annex
              }

              if (resData.result.PublicEstimate !== undefined) {
                // 公示资料
                vm.publicityFilePicList = resData.result.PublicEstimate
              }
              if (resData.result.CloseFile !== undefined) {
                // 归档资料
                vm.closeFilePicList = resData.result.CloseFile
              }
              if (resData.result.Valuation !== undefined) {
                // 公估资料
                vm.valuationFilePicList = resData.result.Valuation
              }
              if (resData.result.PaperScan !== undefined) {
                // 上传扫描件资料
                vm.scanFilePicList = resData.result.PaperScan
              }

              if (resData.result.AddMaterialDailyPhoto !== undefined) {
                // 日常照
                vm.dailyPhotoPicList = resData.result.AddMaterialDailyPhoto
              }

              if (resData.result.AddMaterialPlainPhoto !== undefined) {
                // 计划照
                vm.plainPhotoPicList = resData.result.AddMaterialPlainPhoto
              }

              if (resData.result.AddMaterialSMSPhoto !== undefined) {
                // 短信照
                vm.SMSPhotoPicList = resData.result.AddMaterialSMSPhoto
              }

              if (resData.result.AddMaterialReceiptPhoto !== undefined) {
                // 收据照
                vm.receiptPhotoPicList = resData.result.AddMaterialReceiptPhoto
              }

              if (resData.result.AddMaterialThankPhoto !== undefined) {
                // 感谢照
                vm.thankPhotoPicList = resData.result.AddMaterialThankPhoto
              }
            }
          } else {
            vm.$alert(res.data.message, '提示', {
              callback: (action) => {
                vm.$router.push('/index/allcase')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    getCosInfo() {
      this.axios
        .get(this.homePath() + '/case-info/getCosInfo')
        .then((res) => {
          const resData = res.data
          if (resData.status === '000000') {
            this.bucketName = resData.data.bucketName
            this.region = resData.data.region
            this.secretId = resData.data.secretId
            this.secretKey = resData.data.secretKey
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    convertFilesName(type, url, obj) {
      if (type === 'valuationFilePicList') {
        var keyArray = url.split('.')
        var keySuffix = keyArray[keyArray.length - 1]
        if (keySuffix.toLowerCase() === 'doc') {
          return obj.replace(/-(.*?)_/i, '_')
        }
      }
      return obj.replace(/(.*?)_/i, '').replace(/(.*?)_/i, '')
    },

    chooseImage(type, event) {
      const that = this
      // let src
      // const url = window.URL || window.webkitURL || window.mozURL
      const files = event.target.files
      that.uploadImage(type, files)
      event.target.value = ''
    },

    uploadImage(type, files) {
      const vm = this

      /*  for (let i = 0; i < files.length; i++) {
        let name =
          files[i].name.split(".")[0].trim() +
          "." +
          files[i].name.split(".")[1];
        let key = new Date().getTime() + "_" + name;

      }*/

      for (let i = 0; i < files.length; i++) {
        vm.uploadingNum++
        const name = files[i].name.split('.')[0].trim() + '.' + files[i].name.split('.')[1]
        const key = new Date().getTime() + '_' + name
        const picObj = { url: '', name: key, percentage: 0 }
        vm[type].push(picObj)
        const n = vm[type].length - 1

        vm.upload_result(type, key, files[i], n)
      }
    },

    async upload_result(type, key, fileObj, n) {
      const vm = this

      const COS = require('cos-js-sdk-v5')
      let cos = {}
      let Bucket = ''
      let Region = ''
      cos = new COS({
        SecretId: vm.secretId, // 密钥id
        SecretKey: vm.secretKey // 密钥的key
      })
      Bucket = vm.bucketName
      Region = vm.region

      cos.putObject(
        {
          Bucket: Bucket, // 桶名-APPID  必须
          Region: Region, // 区域 必须
          Key: key, // 文件名必须
          StorageClass: 'Standard_IA',
          Body: fileObj, // 上传文件对象
          onProgress: function(progressData) {
            vm[type][n].percentage = progressData.percent * 100
          }
        },
        function(err, data) {
          if (err) {
            vm.uploadingNum = 0
            console.info(err)
            console.info({ success: false, msg: '文件上传失败!' })
            return
          }

          const picUrl = 'http://' + Bucket + '.picgz.myqcloud.com/' + key
          const picObj = { url: picUrl, name: key }
          vm[type][n] = picObj
          vm.uploadingNum--
          const index = type.substring(0, type.lastIndexOf('FilePicList')) + '_canvas_' + n

          vm.tiffImage(picUrl, index)
        }
      )
    },

    delLi(type, index) {
      if (this.uploadingNum > 0) {
        this.uploadingNum--
      }
      let thisNode = null
      if (type === 'dailyPhotoPicList') {
        this.delList['AddMaterialDailyPhoto'].push(this[type][index])
        thisNode = document.getElementById('dailyPhoto_canvas_' + index)
      }

      if (type === 'plainPhotoPicList') {
        this.delList['AddMaterialPlainPhoto'].push(this[type][index])
        thisNode = document.getElementById('plainPhoto_canvas_' + index)
      }

      if (type === 'SMSPhotoPicList') {
        this.delList['AddMaterialSMSPhoto'].push(this[type][index])
        thisNode = document.getElementById('SMSPhoto_canvas_' + index)
      }

      if (type === 'receiptPhotoPicList') {
        this.delList['AddMaterialReceiptPhoto'].push(this[type][index])
        thisNode = document.getElementById('receiptPhoto_canvas_' + index)
      }

      if (type === 'thankPhotoPicList') {
        this.delList['AddMaterialThankPhoto'].push(this[type][index])
        thisNode = document.getElementById('thankPhoto_canvas_' + index)
      }
      this[type].splice(index, 1)
      if (thisNode !== null) {
        thisNode.parentElement.removeChild(thisNode)
      }
    },

    showImg(type) {
      const routeUrl = this.$router.resolve({
        path: '/showImg',
        query: {
          caseCode: this.cases.caseCode,
          type: type,
          t: new Date().getTime()
        }
      })

      window.open(routeUrl.href, '_blank')
    },

    savePic(type) {
      // 保存
      const attachmentList = {}
      if (type === 'scanFilePicList') {
        this.scanFileloading = true
        attachmentList['PaperScan'] = this.scanFilePicList
        this.delList = {}
      } else if (type === 'valuationFilePicList') {
        this.valuationFileloading = true
        attachmentList['Valuation'] = this.valuationFilePicList
        this.delList = {}
      } else if (type === 'publicityFilePicList') {
        this.publicityFileloading = true
        attachmentList['PublicEstimate'] = this.publicityFilePicList
        this.delList = {}
      } else if (type === 'closeFilePicList') {
        this.closeFileloading = true
        attachmentList['CloseFile'] = this.closeFilePicList
        this.delList = {}
      } else if (type === 'allPhotoPicList') {
        this.allPhotoloading = true
        attachmentList['AddMaterialDailyPhoto'] = this.dailyPhotoPicList
        attachmentList['AddMaterialPlainPhoto'] = this.plainPhotoPicList
        attachmentList['AddMaterialSMSPhoto'] = this.SMSPhotoPicList
        attachmentList['AddMaterialReceiptPhoto'] = this.receiptPhotoPicList
        attachmentList['AddMaterialThankPhoto'] = this.thankPhotoPicList
      }
      this.saveFile(attachmentList)
    },

    saveFile(attachmentList) {
      const vm = this
      const newdelList = {}
      if (Object.keys(vm.delList).length > 0) {
        if (vm.delList.AddMaterialDailyPhoto.length > 0) {
          newdelList['AddMaterialDailyPhoto'] = vm.delList.AddMaterialDailyPhoto
        }

        if (
          vm.delList.AddMaterialPlainPhoto &&
          vm.delList.AddMaterialPlainPhoto.length > 0
        ) {
          newdelList['AddMaterialPlainPhoto'] = vm.delList.AddMaterialPlainPhoto
        }
        if (vm.delList.AddMaterialSMSPhoto && vm.delList.AddMaterialSMSPhoto.length > 0) {
          newdelList['AddMaterialSMSPhoto'] = vm.delList.AddMaterialSMSPhoto
        }
        if (
          vm.delList.AddMaterialReceiptPhoto &&
          vm.delList.AddMaterialReceiptPhoto.length > 0
        ) {
          newdelList['AddMaterialReceiptPhoto'] = vm.delList.AddMaterialReceiptPhoto
        }
        if (
          vm.delList.AddMaterialThankPhoto &&
          vm.delList.AddMaterialThankPhoto.length > 0
        ) {
          newdelList['AddMaterialThankPhoto'] = vm.delList.AddMaterialThankPhoto
        }
      }

      const attm = {
        caseCode: vm.cases.caseCode,
        attachmentList: attachmentList,
        delList: newdelList
      }
      vm.axios
        .put(vm.homePath() + '/casesCommon/uploadImage', attm)
        .then((res) => {
          if (res.data.status === '000000') {
            vm.$alert('保存成功', '提示')
          } else {
            vm.$alert(res.data.message, '提示')
          }

          this.scanFileloading = false
          this.valuationFileloading = false
          this.publicityFileloading = false
          this.closeFileloading = false
          this.allPhotoloading = false
        })
        .catch((error) => console.log(error))
    },

    getdiseaseList() {
      // 疾病名称
      const vm = this
      vm.axios
        .get(vm.homePath() + '/organ-parts-diagnosis/list')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.data
            vm.diseaseList = vm.filterNull(vm.toTreeData(data, 'parentCode', 'code'))
          } else {
            vm.$alert(res.data.message, '提示', {
              callback: (action) => {
                vm.$router.push('/index/allcase')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 查询收费类型
     */
    // getChargeType() {
    //   let vm = this;
    //   vm.axios
    //     .get(vm.homePath() + "/case/getChargeTypeEnumList")
    //     .then((res) => {
    //       if (res.data.status == "000000") {
    //         let data = res.data.enums;
    //         vm.chareTypeList = data;
    //       } else {
    //         vm.$alert(res.data.message, "提示", {
    //           callback: (action) => {
    //             vm.$router.push("/index/allcase");
    //           },
    //         });
    //       }
    //     })
    //     .catch((error) => console.log(error));
    // },

    getaccidentTypeList() {
      // 事故类型
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/getAccidentTypeEnumList')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.enums
            vm.accidentTypeList = data
          } else {
            vm.$alert(res.data.message, '提示', {
              callback: (action) => {
                vm.$router.push('/index/allcase')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },
    getDiseaseType(degreeCode) {
      // 根据部位器官诊断信息，查询疾病库相关信息
      const vm = this
      vm.axios
        .get(this.homePath() + '/disease/disease-library-info?degreeCode=' + degreeCode)
        .then((res) => {
          if (res.data.status === '000000') {
            const resData = res.data.data
            if (resData != null) {
              vm.cases.libraryName = resData.libraryName
              vm.cases.degreeName = resData.degreeName
            }
          } else {
            vm.$alert(res.data.message, '提示', {
              callback: (action) => {
                vm.$router.push('/index/allcase')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    diseaseChange(val) {
      if (val != null) {
        this.cases.degreeCode = val
        this.cases.degreeName = this.$refs['disease'].getCheckedNodes()[0].label
        this.getDiseaseType(val)
      } else {
        this.cases.libraryName = ''
        this.cases.degreeName = ''
      }
      this.calcRiskLevel()
    },
    tnmChange(val) {
      if (val != null) {
        this.cases.tnmName = this.$refs['tnm'].getCheckedNodes()[0].label
      } else {
        this.cases.tnmName = ''
      }
    },
    hzTypeChange(val) {
      this.hzTypeResult = val
      this.caseHelpMoney()
    },

    /**
     * 意外-风险选择器改变事件
     * @param {string} 修改的value值
     * @param {boolean} 标记判断是否查询最高互助金
     */
    riskChange(val, type = false) {
      if (
        this.cases.isRiskMovement === 1 ||
        this.cases.isRiskJob === 1 ||
        this.cases.isRiskTask === 1
      ) {
        this.ywhzType = [{ code: 2, name: '高风险意外' }]
        this.cases.ywMutualStandard = 2
      } else {
        // 因为选择了高风险运动、职业、作业，互助只能选高风险，所以this.ywhzType有可能会变化，初始化时要初始化一次this.ywhzType
        this.ywhzType = [
          { code: 0, name: '未选择' },
          { code: 1, name: '一般意外' },
          { code: 2, name: '高风险意外' }
        ]
      }

      if (type) {
        this.caseHelpMoney()
      }
    },
    chargeTypeChange(val) {
      this.cases.chargeType = val
    },
    firstDiagnosisTimeChange() {
      this.caseHelpMoney()
    },
    symptomAppearanceTimeChange() {
      this.calcRiskLevel()
    },

    lifeTrackChange(val) {
      this.cases.lifeTrack = val
      this.calcRiskLevel()
    },
    hiddenDiseaseHistoryChange(val) {
      this.cases.hiddenDiseaseHistory = val
      this.calcRiskLevel()
    },
    thirdPartyInsuranceChange(val) {
      this.cases.thirdPartyInsurance = val
      this.calcRiskLevel()
    },
    riskAppendChange(val) {
      this.cases.riskAppend = val
      this.calcRiskLevel()
    },

    calcRiskLevel() {
      // 计算案件风险度
      const vm = this
      const cancer =
        vm.cases.symptomAppearanceTime == null ||
        vm.cases.symptomAppearanceTime === '' ||
        vm.cases.degreeCode == null ||
        vm.cases.degreeCode === ''

      const accident =
        vm.cases.memberDeathTime == null ||
        vm.cases.memberDeathTime === '' ||
        vm.cases.accidentType == null ||
        vm.cases.accidentType === ''

      // 如果抗癌和意外的必填项都为空，即不用请求计算风险度
      if (cancer === true && accident === true) {
        return
      }

      let url = 'caseCode=' + vm.cases.caseCode
      if (vm.cases.symptomAppearanceTime != null) {
        url +=
          '&symptomAppearanceTime=' +
          vm.cases.symptomAppearanceTime +
          '&degreeCode=' +
          vm.cases.degreeCode
      }
      if (vm.cases.accidentType != null) {
        url +=
          '&memberDeathTime=' +
          vm.cases.memberDeathTime +
          '&accidentType=' +
          vm.cases.accidentType
      }

      const lifeTrack = vm.cases.lifeTrack == null ? '0' : vm.cases.lifeTrack
      const thirdPartyInsurance =
        vm.cases.thirdPartyInsurance == null ? '0' : vm.cases.thirdPartyInsurance
      const hiddenDiseaseHistory =
        vm.cases.hiddenDiseaseHistory == null ? '0' : vm.cases.hiddenDiseaseHistory
      const riskAppend = vm.cases.riskAppend == null ? '0' : vm.cases.riskAppend

      const riskUrl =
        '&lifeTrack=' +
        lifeTrack +
        '&thirdPartyInsurance=' +
        thirdPartyInsurance +
        '&hiddenDiseaseHistory=' +
        hiddenDiseaseHistory +
        '&riskAppend=' +
        riskAppend

      vm.axios
        .get(vm.homePath() + '/case-info/case-risk-level?' + url + riskUrl)
        .then((res) => {
          if (res.data.status === '000000') {
            const resData = res.data.data
            vm.cases.caseRisk = resData
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 意外-事故类型选择器改变事件
     */
    accidentTypeChange(val) {
      const cases = this.cases
      this.cases.accidentType = val
      this.caseHelpMoney()

      // 判断如果是可编辑的模式下，才可以做修改
      if (
        (cases.flowCode + '').substring(0, 4) === '1005' ||
        (cases.flowCode + '').substring(0, 4) === '1000'
      ) {
        this.getCalcSurveyPay()
        this.cases.chargeType = '' // 初始化收费类型-选中的值
      }
    },

    /**
     * 计算调查和收费
     * @param {boolean} state 区分当前调用是否为加载案件信息的时候调用
     */
    getCalcSurveyPay(state = false) {
      // 程度
      const vm = this
      let degreeCode = vm.cases.degreeCode
      if (degreeCode == null) {
        degreeCode = ''
      }

      // 事故类型
      let accidentType = vm.cases.accidentType
      if (accidentType == null) {
        accidentType = ''
      }

      // icd编号
      let icdId = vm.cases.diseaseIcdInfo.id
      if (icdId == null) {
        icdId = ''
      }

      vm.axios
        .get(
          vm.homePath() +
            '/case-info/cal-survey-pay?caseCode=' +
            vm.cases.caseCode +
            '&degreeCode=' +
            degreeCode +
            '&accidentType=' +
            accidentType +
            '&icdId=' +
            icdId
        )
        .then((res) => {
          const resData = res.data.data
          if (resData != null) {
            vm.surveyPayResult = res.data.survey === 1 ? '是' : '否'
            if (resData.chargeType != null) {
              vm.chareTypeList = resData.chargeType
              // vm.cases.chargeType = resData.chargeType;
              // vm.cases.chargeTypeName = resData.chargeTypeName;
            }
          }

          // 注意：加载案件详情的时候不做报错提示
          if (res.data.status !== '000000' && !state) {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    updateRechargeInfo() {
      // 保存收费类型
      const vm = this
      const rechargeInfo = {
        caseCode: vm.cases.caseCode,
        chargeType: vm.cases.chargeType,
        infoVersion: vm.cases.infoVersion,
        lifeTrack: vm.cases.lifeTrack,
        thirdPartyInsurance: vm.cases.thirdPartyInsurance,
        hiddenDiseaseHistory: vm.cases.hiddenDiseaseHistory,
        riskAppend: vm.cases.riskAppend
      }

      vm.axios
        .put(vm.homePath() + '/case/fee/chargeType', rechargeInfo)
        .then((res) => {
          if (res.data.status === '000000') {
            vm.$alert('保存成功', '提示', {
              callback: (action) => {
                vm.getcaseInfo()
              }
            })
          } else {
            vm.$alert(res.data.message, '提示')
          }
          vm.applyloading = false
        })
        .catch((error) => console.log(error))
    },

    saveApplyInfo() {
      // 保存互助信息
      const vm = this
      vm.applyloading = true

      const applyInfo = {
        flowCode: vm.cases.flowCode,
        caseCode: vm.cases.caseCode,
        detailVersion: vm.cases.detailVersion,

        // ================抗癌================
        degreeCode: vm.cases.degreeCode,
        firstDiagnosisTime: vm.cases.firstDiagnosisTime,
        symptomAppearanceTime: vm.cases.symptomAppearanceTime,
        survey: vm.cases.survey,
        chargeType: vm.cases.chargeType,
        kyMutualStandard: vm.cases.kyMutualStandard,

        // ================意外================
        accidentTime: vm.cases.accidentTime,
        memberDeathTime: vm.cases.memberDeathTime,
        accidentType: vm.cases.accidentType,
        accidentVehicle: vm.cases.accidentVehicle,
        driverLicenseValid: vm.cases.driverLicenseValid,
        ywMutualStandard: vm.cases.ywMutualStandard,

        isRiskMovement: vm.cases.isRiskMovement,
        riskMovement: vm.cases.riskMovement,
        riskMovementRemark: vm.cases.riskMovementRemark,
        isRiskJob: vm.cases.isRiskJob,
        riskJob: vm.cases.riskJob,
        isRiskTask: vm.cases.isRiskTask,
        riskTask: vm.cases.riskTask,
        riskTaskRemark: vm.cases.riskTaskRemark,

        // ================ICD================
        icdId: vm.cases.diseaseIcdInfo.id,
        tnmName: vm.cases.tnmName,
        mutualMoney: vm.cases.mutualMoney,

        // ================费用计算================
        cureTotal: vm.cases.cureTotal === '' ? 0 : vm.cases.cureTotal,
        thirdPartyExpense:
          vm.cases.thirdPartyExpense === '' ? 0 : vm.cases.thirdPartyExpense,
        socialSecurityExpense:
          vm.cases.socialSecurityExpense === '' ? 0 : vm.cases.socialSecurityExpense,
        // ================风险度信息================
        lifeTrack: vm.cases.lifeTrack,
        thirdPartyInsurance: vm.cases.thirdPartyInsurance,
        hiddenDiseaseHistory: vm.cases.hiddenDiseaseHistory,
        riskAppend: vm.cases.riskAppend
      }

      vm.axios
        .put(vm.homePath() + '/case-info/aid-info', applyInfo)
        .then((res) => {
          if (res.data.status === '000000') {
            vm.$alert('保存成功', '提示', {
              callback: (action) => {
                vm.getcaseInfo()
              }
            })
          } else {
            vm.$alert(res.data.message, '提示')
          }
          vm.applyloading = false
        })
        .catch((error) => console.log(error))
    },

    getCaseAbstractList() {
      // 获取摘要信息

      this.axios
        .get(
          this.homePath() +
            '/case-abstract/getCaseAbstract?caseCode=' +
            this.cases.caseCode
        )
        .then((response) => {
          const result = response.data
          if (result.status === '000000') {
            this.abstractList = result.data.trialList
          } else {
            this.$alert(result.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 添加摘要
     * @param {number} abstractType 1001,"审核摘要";1002, "沟通摘要";1003, "法务摘要"
     */
    addAbstract(abstractType) {
      this.abstractloading = true
      // this.abstract.caseCode = this.cases.caseCode;
      const { cases, abstract } = this
      this.axios({
        url: this.homePath() + '/case-abstract/addCaseAbstract',
        method: 'post',
        data: {
          abstractType,
          caseCode: cases.caseCode,
          content: abstract.content
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status === '000000') {
            this.getCaseAbstractList()
            this.abstract.content = ''
          } else {
            this.$alert(result.message, '提示')
          }

          this.abstractloading = false
        })
        .catch((error) => {
          console.log(error)
        })
    },

    updatePublicityInfo() {
      // 保存公示信息
      const vm = this
      const publicityInfo = {
        caseCode: vm.cases.caseCode,
        flowCode: vm.cases.flowCode,
        detailVersion: vm.cases.detailVersion,
        publicityNumber: vm.cases.publicityNumber,
        publicityContent: vm.cases.publicityContent,
        publicityEnd: vm.cases.publicityEnd,
        publicityStart: vm.cases.publicityStart
      }

      this.axios({
        url: this.homePath() + '/case-info/publicity-info',
        method: 'put',
        data: JSON.stringify(publicityInfo),
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status === '000000') {
            this.$alert('操作成功', '提示', {
              callback: (action) => {
                this.getcaseInfo()
              }
            })
          } else {
            this.$alert(result.message, '提示')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateArchiveInfo() {
      // 保存归档信息
      const vm = this
      var archiveInfo = {
        caseCode: vm.cases.caseCode,
        flowCode: vm.cases.flowCode,
        detailVersion: vm.cases.detailVersion,
        archiveNumber: vm.cases.archiveNumber,
        archiveContent: vm.cases.archiveContent
      }

      vm.axios({
        url: vm.homePath() + '/case-info/archive-info',
        method: 'put',
        data: JSON.stringify(archiveInfo),
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status === '000000') {
            vm.$alert('操作成功')
            vm.getcaseInfo()
          } else {
            vm.$alert(result.message, '提示')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // ********************************历史处理记录***********************************
    getCaseOperationList() {
      // 获取历史处理记录
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case-operation-record/' + vm.cases.caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.data
            vm.operationList = data
          } else {
            vm.$alert(res.data.message, '提示', {
              callback: (action) => {
                vm.$router.push('/index/allcase')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },
    slide(type) {
      if (type === 1) {
        this.minHeight = 'auto'
      } else if (type === 2) {
        this.minHeight = '240px'
      }

      this.isshow = !this.isshow
    },

    showHistory(index) {
      // 查看历史处理记录信息
      const historyType = this.operationList[index].type
      const historyData = this.operationList[index].remark
      if (historyType === 2) {
        const healthyDetail = JSON.parse(historyData).healthyDetail
        const listDetail = JSON.parse(historyData).listDetail
        if (healthyDetail && healthyDetail.length > 0) {
          let result = ''
          let optionremark = ''
          for (let i = 0; i < healthyDetail.length; i++) {
            healthyDetail[i].option.filter((item) => {
              if (item.checked) {
                result = item.tip
                optionremark = item.remark
              }
            })
            healthyDetail[i].result = result
            healthyDetail[i].optionremark = optionremark
          }
          this.remark = JSON.stringify(healthyDetail)
        }

        if ((listDetail && listDetail !== '') || listDetail != null) {
          this.remark = JSON.stringify(listDetail)
          console.log(JSON.parse(this.remark))
        }
      } else if (historyType === 5) {
        this.remark = JSON.parse(historyData)
      } else {
        this.remark = historyData
      }

      this.drawerType = String(historyType)
      this.showdrawer = true
    },
    showRuleAnswerContent(index) {
      // 查看历史处理记录信息
      this.remarkArray = JSON.parse(this.operationList[index].ruleAnswerContent)
      this.drawerType = 3
      this.showdrawer = true
    },
    // code:按钮类型，msg:按钮说明，type:表单类型,isMiss:忽略不用发邮件操作
    updateFlow(code, msg, type, isMiss) {
      // const _this = this
      // 更新流程（点击上一步、下一步按钮）
      // 如果当前是正常通过，即判断当前是否要弹出右边框
      if (this.answerRuleResult.code === 0) {
        if (type === 'reportSupplementAssessNext') {
          this.showdrawerbox('reportSupplementAssessNext')
          return
        } else if (type === 'investigation') {
          this.showdrawerbox('investigation')
          return
        }
      }
      // 如果当前
      // isMiss 有些流程的按钮是一定不用发邮件的，比如【初审:核对材料:资料是否完整】的【资料合格完整】
      var req = {
        answerJson: isMiss === undefined || isMiss === true ? 101 : 0,
        caseCode: this.cases.caseCode
      }
      // 当前操作是撤案或者不予互助的话
      if (code === 1 || code === 2) {
        req.answerJson = code
      }
      this.axios
        .post(this.homePath() + '/flow-mail/mails', req)
        .then((res) => {
          if (res.data.status === '000000') {
            // const cases = _this.cases
            var respEmailList = res.data.data
            // 如果有邮件模板
            if (respEmailList !== undefined && respEmailList.length > 0) {
              var emailTab = []
              respEmailList.forEach((emailItem) => {
                // 判断当前是否为“已审批(审核评估) 流程编号：101570”
                // 控制显示的邮件类型
                // 如果是抗癌计划的互助标准（一般：不显示有回执/无回执、低度：不显示审批结果通知函）其他照常显示不做限制
                // 如果是意外计划的互助标准（一般：不显示有回执/无回执、高风险意外：不显示审批结果通知函）其他照常显示不做限制
                var templateType = emailItem.templateType.substring(4, 6)
                /*  if(cases.flowCode == '101570') {
                  if(cases.productName.substring(0, 2) == '抗癌') {  // 抗癌
                    if(cases.kyMutualStandard == 1) { // 低度
                      if(templateType != '15') {
                        emailTab.push("tab" + templateType);
                      }
                    } else if(cases.kyMutualStandard == 2) {  // 一般
                      if(templateType != '07' && templateType != '18') {
                        emailTab.push("tab" + templateType);
                      }
                    }
                  } else if(cases.productName.substring(0, 2) == '意外') { // 意外
                    if(cases.ywMutualStandard == 1) { // 一般意外
                      if(templateType != '07' && templateType != '18') {
                        emailTab.push("tab" + templateType);
                      }
                    } else if(cases.ywMutualStandard == 2) {  // 高风险意外
                      if(templateType != '15') {
                        emailTab.push("tab" + templateType);
                      }
                    }
                  }
                } else {*/
                emailTab.push('tab' + templateType)
                // }
              })

              this.emailDialog = true
              this.showEmailTab = emailTab
              this.showEmailMsg = msg
              this.showEmailCode = code
              this.showButton = false
            } else {
              this.updateCaseFlow(code, msg)
            }
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    updateCaseFlow(code, msg) {
      // 更新流程（点击上一步、下一步按钮）
      const vm = this

      vm.$confirm('确定要进行' + msg + '操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const updateObj = {
            version: vm.cases.infoVersion,
            caseCode: vm.cases.caseCode,
            remark: vm.cases.backRemark,
            menuCode: code,
            buttonName: msg
          }

          vm.axios({
            url: vm.homePath() + '/casesCommon/caseNextStep',
            method: 'put',
            data: JSON.stringify(updateObj),
            headers: {
              'Content-type': 'application/json'
            }
          })
            .then((res) => {
              const result = res.data
              if (result.status === '000000') {
                vm.$alert('操作成功', '提示', {
                  callback: (action) => {
                    vm.getcaseInfo()
                    this.emailDialog = false
                  }
                })
              } else {
                vm.$alert(result.message, '提示')
              }
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch(() => {})
    },
    getTaskInfo() {
      // 获取任务信息
      const currentfrom = this.$route.query.from

      if (currentfrom === 'task' || currentfrom === 'mytask') {
        this.taskCode = this.$route.query.taskCode
        this.taskVersion = this.$route.query.taskVersion
      }
    },

    updateTask(code, msg) {
      // 更新任务
      const vm = this
      vm.$confirm('确定要进行' + msg + '操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const updateObj = {
            caseCode: vm.cases.caseCode,
            handleTask: code,
            taskCode: vm.taskCode,
            taskVersion: vm.taskVersion
          }

          vm.axios({
            url: vm.homePath() + '/case-task/handle',
            method: 'post',
            data: JSON.stringify(updateObj),
            headers: {
              'Content-type': 'application/json'
            }
          })
            .then((res) => {
              const result = res.data
              if (result.status === '000000') {
                const currentfrom = this.$route.query.from
                if (currentfrom === 'task') {
                  vm.$alert('操作成功', '提示', {
                    callback: (action) => {
                      vm.$router.push({
                        path: '/index/task'
                      })
                    }
                  })
                } else if (currentfrom === 'mytask') {
                  vm.$alert('操作成功', '提示', {
                    callback: (action) => {
                      vm.$router.push({
                        path: '/index/mytask'
                      })
                    }
                  })
                }
              } else {
                vm.$alert(result.message, '提示')
              }
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch(() => {})
    },

    /**
     * 最高互助金额-显示费用计算的弹出层
     */
    calcHelpMoneyBtn() {
      this.calcHelpMoneyBak = {
        cureTotal: this.cases.cureTotal,
        socialSecurityExpense: this.cases.socialSecurityExpense,
        thirdPartyExpense: this.cases.thirdPartyExpense
      }
      this.calcHelpMoneyDialog = true
    },

    /**
     * 最高互助金额-计算最高互助金额，并隐藏弹出层
     */
    onCalculateHelpMoney() {
      this.calcHelpMoneyDialog = false
      this.changeHelpMoney()
    },

    /**
     * 最高互助金额-隐藏费用计算的弹出层
     */
    rollbackCalcHelpMoney() {
      this.calcHelpMoneyDialog = false
      this.cases.cureTotal = this.calcHelpMoneyBak.cureTotal
      this.cases.socialSecurityExpense = this.calcHelpMoneyBak.socialSecurityExpense
      this.cases.thirdPartyExpense = this.calcHelpMoneyBak.thirdPartyExpense
      this.changeHelpMoney()
    },

    /**
     * 查询最高互助金
     */
    caseHelpMoney() {
      const vm = this
      // 如果当前ICD-10是少儿呼吸道，即不用单独计算最高互助金
      if (
        this.cases.diseaseIcdInfo !== undefined &&
        this.cases.diseaseIcdInfo !== null &&
        this.cases.diseaseIcdInfo.degreeType === 1
      ) {
        return
      }

      var params = ''
      if (this.cases.firstDiagnosisTime !== undefined) {
        params += '&firstDiagnosisTime=' + this.cases.firstDiagnosisTime
      }
      if (this.cases.kyMutualStandard !== undefined && this.cases.kyMutualStandard !== 0) {
        params += '&kyMutualStandard=' + this.cases.kyMutualStandard
      }
      if (this.cases.ywMutualStandard !== undefined && this.cases.ywMutualStandard !== 0) {
        params += '&ywMutualStandard=' + this.cases.ywMutualStandard
      }
      if (this.cases.accidentType !== undefined) {
        params += '&accidentType=' + this.cases.accidentType
      }
      if (this.cases.diseaseIcdInfo.id !== undefined) {
        params += '&icdId=' + this.cases.diseaseIcdInfo.id
      }
      if (this.cases.diseaseCode !== undefined) {
        params += '&diseaseCode=' + this.cases.diseaseCode
      }

      this.axios
        .get(
          vm.homePath() +
            '/case/compute/caseHelpMoney?caseCode=' +
            vm.cases.caseCode +
            params
        )
        .then((res) => {
          if (res.data.status === '000000') {
            vm.cases.mutualMoney = res.data.data.helpMoney
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    updateDeadlineTime() {
      const vm = this
      const deadlineTimeInfo = {
        caseCode: vm.cases.caseCode,
        endTime: vm.endDeadlineTime
      }
      vm.axios({
        url: vm.homePath() + '/casesCommon/deadlineTime',
        method: 'put',
        data: JSON.stringify(deadlineTimeInfo),
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status === '000000') {
            vm.$alert('操作成功', '提示')
          } else {
            vm.$alert(result.message, '提示')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    saveFirstTrailResult() {
      // 保存初审结果
      const vm = this
      vm.axios
        .post(
          vm.homePath() +
            '/first-trail/output/answer/' +
            vm.cases.caseCode +
            '/' +
            vm.cases.infoVersion
        )
        .then((res) => {
          if (res.data.status === '000000') {
            vm.$alert('操作成功', '提示', {
              callback: (action) => {
                vm.$router.push('/index/allcase/')
              }
            })
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 初审审核结果信息
     */
    // getCalcTrailResult() {
    //
    //   this.axios
    //     .get(
    //       this.homePath() + "/case-info/cal-trail-result/" + this.cases.caseCode
    //     )
    //     .then((res) => {
    //       if (res.data.status == "000000") {
    //         this.trailResult = res.data.data;
    //       }
    //     })
    //     .catch((error) => console.log(error));
    // },

    saveCollegiateResult() {
      const collegiateReq = {
        version: this.cases.infoVersion,
        caseCode: this.cases.caseCode,
        remark: this.cases.collegiateResult
      }

      this.axios
        .post(this.homePath() + '/caseReview/saveCollegiateResult', collegiateReq)
        .then((res) => {
          this.loading = false
          if (res.data.status === '000000') {
            this.$alert('操作成功', '提示', {
              callback: (action) => {
                this.getcaseInfo()
              }
            })
          } else {
            this.$alert(res.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 分享链接-列表
     */
    getLinks() {
      const vm = this
      this.axios
        .get(vm.homePath() + '/case-info/share-url/list/' + vm.cases.caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            vm.links = res.data.data
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    seeLinks() {
      this.getLinks()
      this.linkListdialog = true
    },

    createLinks() {
      this.axios
        .get(this.homePath() + '/case-info/share-url/' + this.cases.caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            this.getLinks()
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 限制费用计算-治疗总额的金额，最高只能填写“10000”
     */
    onChangeCureTotal(value) {
      if (Number(value) > 10000) {
        this.cases.cureTotal = 10000
      } else {
        this.cases.cureTotal = value
      }
    },

    /**
     * 计算最高互助金
     */
    changeHelpMoney() {
      const { cureTotal, socialSecurityExpense, thirdPartyExpense } = this.cases
      const mutualMoney = cureTotal - socialSecurityExpense - thirdPartyExpense
      if (mutualMoney < 0) {
        // 如果计算的金额小于0元,则将金额还原到上一步的金额,并弹出错误提示
        this.cases.cureTotal = this.calcHelpMoneyBak.cureTotal
        this.cases.socialSecurityExpense = this.calcHelpMoneyBak.socialSecurityExpense
        this.cases.thirdPartyExpense = this.calcHelpMoneyBak.thirdPartyExpense
        this.$message.error('当前计算的最高互助金额小于0元，请填写正确的费用金额！')
      } else {
        this.cases.mutualMoney = mutualMoney
      }
    },
    // ********************************START 告别规则***********************************
    updateRuleResult(questionId, updateItem) {
      console.log('questionId, updateItem', questionId, updateItem)
      const newResult = []
      // 循环当前所有答案
      this.ruleResult.forEach((item) => {
        // 不更新这次问题答案
        if (item.questionCode !== questionId) {
          newResult.push(item)
        }
      })

      // 循环当前所有问题，把当次更新的内容
      this.testItem.forEach((item) => {
        // 更新这次问题答案
        if (item.questionCode === questionId) {
          var currentQuestion = {
            questionCode: item.questionCode,
            questionName: item.questionName,
            options: updateItem
          }
          newResult.push(currentQuestion)
        }
      })
      this.ruleResult = newResult
    },

    /**
     * 保存答题结果
     */
    saveRule() {
      var req = {
        caseCode: this.cases.caseCode,
        paperCode: this.cases.paperCode,
        questions: this.ruleResult
      }

      this.axios
        .post(this.homePath() + '/rule-answer/save', req)
        .then((res) => {
          if (res.data.status === '000000') {
            this.$alert('操作成功', '提示', {
              callback: (action) => {
                this.getcaseInfo()
              }
            })
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    getCaseRuleAnswerList() {
      // 告别规则
      const vm = this
      vm.axios
        .get(vm.homePath() + '/rule-answer/' + vm.cases.caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.data
            vm.testItem = data

            this.ruleResult = []
            // 把已经有的加到结果里，下次只要更新新加的就可以了
            vm.testItem.forEach((item) => {
              var currentQuestion = {
                questionCode: item.questionCode,
                questionName: item.questionName,
                options: []
              }
              if (item.answers != null) {
                item.answers.forEach((answerItem) => {
                  currentQuestion.options.push(answerItem)
                })
              }
              vm.ruleResult.push(currentQuestion)

              // var currentCommunicateItem=
              // {
              // 	"questionCode": item.questionCode,
              // 	"suspectRemarks": []
              // }
              // if(item.communicates!=null){
              // 	item.communicates.forEach(communicateItem=>{
              // 		currentCommunicateItem.suspectRemarks.push(communicateItem);
              // 	});
              // }
              // vm.suspectCommunicateInfos.push(currentCommunicateItem);
            })
          } else {
            vm.$alert('获取告知规则失败，请稍后再试')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 规则库-计算输出拒付理由
     */
    getCalcCaseRuleResult() {
      // 计算结果
      const vm = this
      vm.axios
        .get(vm.homePath() + '/rule-answer/calc/' + vm.cases.caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            vm.answerRuleResult = res.data.data
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 当前案件所有疑点列表
     */
    getCaseRuleSuspectList() {
      // 疑点
      const vm = this
      vm.axios
        .get(vm.homePath() + '/rule-suspect/' + vm.cases.caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.data
            vm.answerList = data
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    // 输入框查询匹配
    querySearch_front(queryString, cb) {
      this.axios
        .get(this.homePath() + '/disease-icd/list-icd?icdName=' + queryString)
        .then((res) => {
          if (res.data.status === '000000') {
            this.nginxServerData = res.data.data
            const restaurants = []
            // 我后端请求回来的数据是个数组放在了nginxServerData的
            for (let i = 0; i < this.nginxServerData.length; i++) {
              // 因为列表框中的数据是必须要用value这个属性的 所以我这里做了处理
              restaurants.push({
                value: this.nginxServerData[i].icdName,
                code: this.nginxServerData[i].icdCode
              })
            }
            // let results = queryString ? restaurants.filter(this.createFilter_front(queryString)) : restaurants
            // 调用 callback 返回建议列表的数据
            cb(restaurants)
          } else {
            this.$alert(res.data.message)
          }
        })
        .catch((error) => console.log(error))
    },
    createFilter_front(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        // 上面这里进行了全局查询所以indexOf条件是 > -1，如果要以开头匹配关键字的话直接把 > -1换成=== 0 就可以了
      }
    },

    /**
     * 诊断名称选择器-选中事件
     */
    handleSelect(item) {
      console.info(item)
      this.nginxServerData.forEach((i) => {
        if (item.code === i.icdCode) {
          this.cases.diseaseIcdInfo.icdCode = i.icdCode
          this.cases.diseaseIcdInfo.icdName = i.icdName
          this.cases.diseaseIcdInfo.id = i.id // icd编号
          this.cases.diseaseIcdInfo.degreeType = i.degreeType
          this.cases.diseaseIcdInfo.degreeTip = i.degreeTip
          this.caseHelpMoney()

          // 判断如果是可编辑的模式下，才可以做修改
          if (
            (this.cases.flowCode + '').substring(0, 4) === '1005' ||
            (this.cases.flowCode + '').substring(0, 4) === '1000'
          ) {
            this.cases.chargeType = '' // 初始化收费类型-选中的值
            this.getCalcSurveyPay()
          }
        }
      })
    },
    // ********************************END 告别规则***********************************
    saveCommunicates() {
      var suspectCommunicateInfos = []
      this.suspectCommunicateInfos.forEach((item) => {
        item.suspectRemarks.forEach((remarkItem) => {
          suspectCommunicateInfos.push({
            questionCode: item.questionCode,
            suspectRemark: remarkItem.suspectRemark
          })
        })
      })
      var req = {
        caseCode: this.cases.caseCode,
        suspectCommunicateInfos: suspectCommunicateInfos
      }
      this.axios
        .post(this.homePath() + '/rule-suspect-communicate/add', req)
        .then((res) => {
          if (res.data.status === '000000') {
            this.$alert('操作成功', '提示', {
              callback: (action) => {
                this.suspectCommunicateInfos = []
                this.getcaseInfo()
              }
            })
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    updateCommunicates(questionCode, updateItem) {
      var newCommunicateInfo = []
      var isExists = false
      // 循环当前所有沟通信息
      if (this.suspectCommunicateInfos.length > 0) {
        this.suspectCommunicateInfos.forEach((item) => {
          // 不更新这次问题答案
          if (item.questionCode !== questionCode) {
            newCommunicateInfo.push(item)
          } else {
            var currentQuestion = {
              questionCode: questionCode,
              suspectRemarks: updateItem
            }
            newCommunicateInfo.push(currentQuestion)
            // 如果当前入参的内容已经写入到suspectCommunicateInfos中
            isExists = true
          }
        })
      }
      // 如果当前请求的入参未加入到suspectCommunicateInfos中，即要push一次
      if (!isExists) {
        var currentQuestion = {
          questionCode: questionCode,
          suspectRemarks: updateItem
        }
        newCommunicateInfo.push(currentQuestion)
      }
      this.suspectCommunicateInfos = newCommunicateInfo
    }
  }
}
</script>
<style scoped lang="scss">
body {
  font-size: 12px;
}
p {
  margin: 0px;
}
.main-con {
  margin: 5px 20px;
}

.detail-box {
  padding: 5px 20px;
}
div.operat-list {
  margin-top: 25px;
  overflow: hidden;
}
.none p {
  line-height: 25px;
  color: #dcdfe6;
  font-size: 14px;
}
.search-con {
  margin: 0px;
}
.title-line {
  height: 30px;
  border-bottom: 1px solid #a1a1a1;
}
.detail-box .el-button {
  font-size: 12px;
  padding: 10px;
}
.detail-box ul.select-option {
  bottom: 0px;
}
.detail-box ul.select-option li {
  margin: 0px 5px;
}

.detail-box .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.detail-box .el-input__icon {
  line-height: 30px;
}
.detail-box .el-input {
  width: auto;
}
.search-con-item__label {
  color: #99a9bf;
}
.part_line {
  border-bottom: 1px dashed #dcdfe6;
  margin-bottom: 3px;
  width: 100%;
}
.el-autocomplete .el-input {
  width: 250px;
}
.mr10 {
  margin-right: 4px;
}
.red {
  color: red;
}

/* 查看影像 */
.case_detail_uploader_files {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;

  .checkbox-block {
    width: 128px;
    display: flex;
    align-items: flex-start;

    /deep/ .el-checkbox__label {
      word-break: break-all;
      flex: 1;
      white-space: normal;
      line-height: 18px;
      text-align: left;
      margin-top: -2px;
    }
  }
}
</style>
